import fecha from 'fecha';
import { Platform } from 'react-native';
import { Actions } from '../../navigation';
import {
  RAIL_SEARCH_CONTEXT_DATA_TYPE,
  RAIL_AVAILABILITY_CARD_DATA_TYPE,
  RAIL_LISTING_PAGE_DATA_TYPE,
  getCommonPdtData,
  getCommonSearchContextData,
  isLocusEmpty,
} from "../../PdtAnalytics/PdtHelper/RailsPdtUtils";
import { railsConfig,SEARCH_CONTEXT } from '../../RailsConfig';
import {
  addMinutes,
  getImageSign,
  updateTimeInfoInSelectedTrain,
  getNecessaryStationDetails,
  updateListingQueryParams,
  getValidDate,
} from './Utils/RailListingUtils';
import {
  trackNewListingClickEvent,
  trackNewListingDateChangeEvent,
  trackNewListingEvent,
  trackNewListingLoad,
  trackNewListingSortEvent,
  trackTravellerPageLoad,
  updateEvar47or97Variable,
  trackConnectedEvar47or97Event,
  removeEventFromEvar47or97Variable,
  trackEventAfterRemovingOlderEvent,
  trackEvar22Event,
  trackOdtEvar47or97Event,
  updateEvarFromLocalStorage,
} from '../../railsAnalytics';
import {setDataInStorage} from '@mmt/legacy-commons/AppState/LocalStorage';
import {
  NO_RESERVATION_CHOICE_CODE,
  INPUT_CITY_SELECTED,
  voucherState,
  LISTING_PAGE_CONST,
  RAILS_LISTING,
  dummyArpResponse,
  API_TIMEOUT,
  LISTING_CONNECTED_TRAVEL_EVENTS,
  LISTING_PAGE_TRACKING_KEY,
  availabilityBucketOmnitureMapping,
  DATE_MONTH_YEAR_FORMAT,
  TRAIN_OUTSIDE_RESERVATION_WINDOW,
  ENTITY,
  COMMON_LATENCY,
  RAILS_DOWNTIME_CACHE,
  RESPONSE_FROM_CACHE,
  NEARBY_DATES_EVENTS,
  ODT_EVENTS,
  RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS,
  DOUBLE_DIGIT_DATE_WITH_MONTH_FORMAT
} from '../../Utils/RailsConstant';
import QuotaType, { getQuota } from '../Types/QuotaType';
import type { QuotaTypeInterface, StationFC } from './interface';
import AvailabilityStatusTypes from '../Types/AvailabilityStatusTypes';
import StationChangeSignType from '../Types/StationChangeSignType';
import { diffDays, getFormattedDateFromDate, twentyFourHourDateTimeFormat } from '@mmt/legacy-commons/Helpers/dateHelpers';
import {showShortToast} from '@mmt/legacy-commons/Common/Components/Toast';
import fetch2, { Timeout } from '../../fetch2';
import {
  AbConfigKeyMappings,
  getPokusConfig
} from '@mmt/legacy-commons/Native/AbConfig/AbConfigModule';
import {PokusLobs} from '@mmt/legacy-commons/Native/AbConfig/AbConfigKeyMappings';
import {ACTION_SET_PPBOOKING_LANDING_DATA} from '../Review/RailsReviewActions';
import {tuneRailsListingLoadTracker} from '../../Utils/railsTuneTracker';
import {
  fireOmnitureEventsNew,
  getFilterObject,
  onClearAllFiltersClickedInListing,
  onFilterIconClick
} from '../RailsFilters/RailsFilterActions';
import { createTicketTypeFilterObj } from '../RailsFilters/railsFilter.utils';
import RailsPdtListingHelper from '../../PdtAnalytics/PdtHelper/RailsPdtListingHelper';
import SortType from '../Types/SortType';
import {botmanSensorHeader} from '@mmt/legacy-commons/Native/NetworkModule';
import AvailabilityStatusValues from '../Types/AvailabilityStatusValues';
import {ACTION_DATE_SELECTED} from "../RailsLandingPage/Store/RailsLandingActionTypes";
import {convertBJTrainInfoToNormalTrainInfo} from "../BreakJourney/BookBreakJourney";
import {getStationDetails} from "../../Utils/CityRepository";
import {
  getBreakJourneyRoutesApi, getBreakJourneyFareAndAvailApi, getDisclamerApi, getPendingLegDetailsApi
} from '../BreakJourney/breakJourney.api';
import {
  getDateDD, getMonthMM, getISTDateFromIsoDate
} from '@mmt/legacy-commons/Common/utils/dateTimeUtil';
import {
  ConfirmationProbabilityResponse
} from '../../types/confirmationProbability.types';
import { fetchConfirmationGuaranteeOption, fetchFreeCancellationOption, trackTotalCardsOnListing } from '../../Utils/railofyUtils';
import {
  FutureSelectedDateData, FutureSelectedTrain
} from '../../types/futureAvailaibility.types';
import {skywalkerSearchConnector} from '../../Skywalker/connector';
import {SearchConnector} from '../../Skywalker/searchConnector';
import {firebaseListingTracker} from '../../Analytics/Firebase/util'
import { getQueryParamsFromUrl } from '@mmt/legacy-commons/Helpers/misc';
import { trackNewListingFromSkyWalker } from '../../railsAnalytics';
import {
  getLocusIdFromStationDetails,
  initAppVersion,
  setLocusData,
} from '../RailsLandingPage/Store/RailsLandingPageActions';
import * as RailsLandingActionTypes from '../RailsLandingPage/Store/RailsLandingActionTypes';
import { pushListingIntoGtm } from '../../GtmConfig/gtmConfig';
import { trackPageVisits,trackClickEventProp61 ,trackListingError} from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import isUndefined from "lodash/isUndefined";
import { _label } from '../../vernacular/AppLanguage';
import {
  getClusterBottomSheetForStationChangeAlert,
  getRailsRouteExtenstionBottomsheet,
  getRailsRouteExtenstionV2,
  getRailsListingSortingLogic,
  getIfToShowFCTGTogether,
  getCanLoadListingv3,
  getCanReportIRCTCError,
  RailsAbConfig,
  getRailsPokusConfig,
  getIfCanShowBNPP,
  getIfToShowRailsConnectedTravel,
  getNearbyDatesNew,
  getIfToShowConnectedTravelV2,
  getRailsCtSource,
  getRailsAvailDepletion,
} from '../../RailsAbConfig'
import { getMigratedTrainsList } from 'apps/rails/src/pages/NewListing/RailsListingActionsV3';
import { getAlternateAvailabilityResponse, getDataForConfirmedOptions } from './Components/ConfirmedOptions/ConfirmedOptionsUtils';
import RailsModule from '@mmt/legacy-commons/Native/RailsModule';
import { getUserDetails } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { getCurrentInternetConnectionAndApproxSpeed } from '@mmt/legacy-commons/Common/utils/AppUtils';
import { logGrafanaLatencyMetrics } from '@mmt/rails/src/Utils/RailsGrafanaTracker';
import { calculateTtuExtent, removeTtuTrackingEvars } from '../../Utils/RailsOmnitureUtils';
import { ENTITY_TYPE, PAGE } from 'apps/rails/src/types/grafanaTracking.types';
import { logGrafanaErrorMetrics } from '../../Utils/RailsGrafanaTracker';
import {
  getDataForConfirmedOptionsBottomSheet,
  getNearbyDatesurl,
  getSelectedCardHash,
  getTrainDataForNearbyDatesConfirmedOption,
} from './Components/NearByDates/Utils/NearByDatesUtils';
import { configKeys } from '../../configStore/Common/constants';
import { getConfigStore } from '../../configStore/Common/RailsConfigStoreUtils';
import RAIL_EVENTS from 'apps/rails/src/RailsOmnitureTracker';
import { logLandingEvent } from '../../PdtAnalytics/PdtAnalyticsV2/PdtRailsLanding';
import { buildSearchContextFromState } from '../../PdtAnalytics/PdtAnalyticsV2/PdtV2Utils';
export const ACTION_RAILS_LISTING_INIT_STATE = '@rails/ACTION_RAILS_LISTING_INIT_STATE';
export const ACTION_RAIL_LISTING_SHOW_WEBVIEW = '@rails/ACTION_RAIL_LISTING_SHOW_WEBVIEW';
export const ACTION_RAIL_LISTING_REMOVE_WEBVIEW = '@rails/ACTION_RAIL_LISTING_REMOVE_WEBVIEW';
export const ACTION_RAILS_LISTING_COMPLETE = '@rails/ACTION_RAILS_LISTING_COMPLETE';
export const ACTION_RAILS_LISTING_ERROR = '@rails/ACTION_RAILS_LISTING_ERROR';
export const ACTION_SET_LIST_SORTED_ORDER = '@rails/ACTION_SET_LIST_SORTED_ORDER';
export const ACTION_TRAIN_SELECTED = '@rails/ACTION_TRAIN_SELECTED';
export const ACTION_CLOSE_CLASS_AVAILABILITY = '@rails/ACTION_CLOSE_CLASS_AVAILABILITY';
export const ACTION_QUOTA_TYPE_SELECTED = '@rails/ACTION_QUOTA_TYPE_SELECTED';
export const ACTION_SET_ALL_AVAILABLE_CLASSES = '@rails/ACTION_SET_ALL_AVAILABLE_CLASSES';
export const ACTION_SET_CLASS_TYPE_SELECTED = '@rails/ACTION_SET_CLASS_TYPE_SELECTED';
export const ACTION_IRCTC_BOOKING_ERROR = '@rails/ACTION_IRCTC_BOOKING_ERROR';
export const ACTION_TATKAL_BOOKING_ERROR = '@rails/ACTION_TATKAL_BOOKING_ERROR';
export const ACTION_SET_AVAILABILITY_LIST = '@rails/ACTION_SET_AVAILABILITY_LIST';
export const ACTION_INIT_AVAILABILITY_LIST = '@rails/ACTION_INIT_AVAILABILITY_LIST';
export const ACTION_SELECTED_BOOKING_DATE = '@rails/ACTION_SELECTED_BOOKING_DATE';
export const ACTION_STATION_CHANGE_ALERT = '@rails/ACTION_STATION_CHANGE_ALERT';
export const ACTION_PREFILL_DATA_FOR_POPUP = '@rails/ACTION_PREFILL_DATA_FOR_POPUP';
export const ACTION_SCHEDULE_TATAKAL_BOTTOM_SHEET = '@rails/ACTION_SCHEDULE_TATAKAL_BOTTOM_SHEET';
export const ACTION_UPDATE_SELECTED_TRAIN_INFO_JOURNEY_DATE = '@rails/ACTION_UPDATE_SELECTED_TRAIN_INFO_JOURNEY_DATE';
export const ACTION_UPDATE_TBS_AVAILABILITY = '@rails/ACTION_UPDATE_TBS_AVAILABILITY';
export const ACTION_UPDATE_TBS_CONFIRM_PROBABLITY = '@rails/ACTION_UPDATE_TBS_CONFIRM_PROBABLITY';
export const ACTION_SET_DATA_FOR_TRAVELERS_PAGE = '@rails/ACTION_SET_DATA_FOR_TRAVELERS_PAGE';
export const ACTION_UPDATE_QUOTA_SELECTED_OF_TRAIN = '@rails/ACTION_UPDATE_QUOTA_SELECTED_OF_TRAIN';
export const ACTION_UPDATE_CLASS_TYPE_SELECTED_OF_TRAIN = '@rails/ACTION_UPDATE_CLASS_TYPE_SELECTED_OF_TRAIN';
export const ACTION_UPDATE_AVAILABILITY_OF_TRAIN = '@rails/ACTION_UPDATE_AVAILABILITY_OF_TRAIN';
export const ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN = '@rails/ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN';
export const ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN_FOR_ODT = '@rails/ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN_FOR_ODT';
export const ACTION_SET_HOTELS_CROSS_SELL_DATA = '@rails/ACTION_SET_HOTELS_CROSS_SELL_DATA';
export const ACTION_SET_VOUCHER_OBJECT = '@rails/ACTION_SET_VOUCHER_OBJECT';
export const ACTION_INIT_RAILS_LISTING_FILTERS = '@rails/ACTION_INIT_RAILS_LISTING_FILTERS';
export const ACTION_SET_FILTER = '@rails/ACTION_SET_FILTER';
export const ACTION_COMMIT_TRAIN_AND_FILTER = '@rails/ACTION_COMMIT_TRAIN_AND_FILTER';
export const ACTION_SET_QUICK_FILTER = '@rails/ACTION_SET_QUICK_FILTER';
export const ACTION_SET_LISTING_QUICK_FILTER = '@rails/ACTION_SET_LISTING_QUICK_FILTER';
export const ACTION_INIT_FILTER_STATE = '@rails/ACTION_INIT_FILTER_STATE';
export const ACTION_SET_TO_PREV_FILTER_STATE = '@rails/ACTION_SET_TO_PREV_FILTER_STATE';
export const ACTION_CLEAR_ALL_FILTERS_ON_FILTER_PAGE = '@rails/ACTION_CLEAR_ALL_FILTERS_ON_FILTER_PAGE';
export const ACTION_CLEAR_SELECTED_FILTERS_ON_FILTER_PAGE = '@rails/ACTION_CLEAR_SELECTED_FILTERS_ON_FILTER_PAGE';
export const ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE = '@rails/ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE';
export const ACTION_INIT_SHOW_CONFIRMATION_CHANCE_AB = '@rails/ACTION_INIT_SHOW_CONFIRMATION_CHANCE_AB';
export const ACTION_INIT_SHOW_CONFIRMATION_CHANCE_V2_AB = '@rails/ACTION_INIT_SHOW_CONFIRMATION_CHANCE_V2_AB';
export const ACTION_INIT_RAIL_LISTING_V3_AB = '@rails/ACTION_INIT_RAIL_LISTING_V3_AB';
export const ACTION_SET_CONFIRMATION_CHANCES = '@rails/ACTION_SET_CONFIRMATION_CHANCES';
export const ACTION_DATE_CHANGED = '@rails/ACTION_DATE_CHANGED';
export const ACTION_SET_CONFIRM_OPTIONS = '@rails/ACTION_SET_CONFIRM_OPTIONS';
export const ACTION_RAILS_LISTING_UPDATE_ORIGIN = '@rails/ACTION_RAILS_LISTING_UPDATE_ORIGIN';
export const ACTION_RAILS_LISTING_UPDATE_DESTINATION = '@rails/ACTION_RAILS_LISTING_UPDATE_DESTINATION';
export const ACTION_RAILS_LISTING_EDIT_ORIGIN = '@rails/ACTION_RAILS_LISTING_EDIT_ORIGIN';
export const ACTION_RAILS_LISTING_EDIT_DESTINATION = '@rails/ACTION_RAILS_LISTING_EDIT_DESTINATION';
export const ACTION_RAIL_LISTING_SHOW_HIDE_EDIT_WIDGET = '@rails/ACTION_RAIL_LISTING_SHOW_HIDE_EDIT_WIDGET';
export const ACTION_RAIL_LISTING_INTIAL_LOADING = '@rails/ACTION_RAIL_LISTING_INTIAL_LOADING';
export const ACTION_RAIL_LISTING_SHOW_LOADING = '@rails/ACTION_RAIL_LISTING_SHOW_LOADING';
export const ACTION_RAIL_LISTING_SEARCH_PARAMS_CHANGED =
  '@rails/ACTION_RAIL_LISTING_SEARCH_PARAMS_CHANGED';
export const ACTION_DATE_SELECTED_LISTING = '@rails/ACTION_DATE_SELECTED_LISTING';
export const ACTION_SWAP_SEARCH_LISTING = '@rails/ACTION_SWAP_SEARCH_LISTING';
export const ACTION_SKIP_UNIVERAL_WIDGET_URL = '@rails/ACTION_SKIP_UNIVERAL_WIDGET_URL';
export const COVID_SAFETY_CARD_LISTING = '@rails/COVID_SAFETY_CARD_LISTING';
export const ACTION_BOOKING_SUCCESS_RAILS = '@rails/ACTION_BOOKING_SUCCESS_RAILS';
export const ACTION_INIT_BREAK_JOURNEY = '@rails/ACTION_INIT_BREAK_JOURNEY';
export const ACTION_CHANGE_BJ_MODAL = '@rails/ACTION_CHANGE_BJ_MODAL';
export const ACTION_BOOK_BJ_LOADING = '@rails/ACTION_BOOK_BJ_LOADING';
export const ACTION_BOOK_BJ_COMPLETE = '@rails/ACTION_BOOK_BJ_COMPLETE';
export const ACTION_BOOK_BJ_GOBACK = '@rails/ACTION_BOOK_BJ_GOBACK';
export const ACTIONS_CLEAR_SELECTED_TRAIN_INFO = '@rails/ACTIONS_CLEAR_SELECTED_TRAIN_INFO';
export const ACTIONS_SET_BJ_TRAIN_INFO = '@rails/ACTIONS_SET_BJ_TRAIN_INFO';
export const ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE = '@rails/ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE';
export const ACTION_BOOK_BJ_REMOVE_LOADER = '@rails/ACTION_BOOK_BJ_REMOVE_LOADER';
export const ACTION_SET_ALTERNATE_AVAILABILTY_LIST = '@rails/ACTION_SET_ALTERNATE_AVAILABILTY_LIST';
export const CONFIRMATION_GUARANTEE_FILTER_FILL = '@rails/CONFIRMATION_GUARANTEE_FILTER_FILL';
export const SAVE_CONFIRMATION_GUARANTEE_POKUS_OPTION = '@rails/SAVE_CONFIRMATION_GUARANTEE_POKUS_OPTION';
export const CONFIRMATION_GUARANTEE_ERROR = '@rails/CONFIRMATION_GUARANTEE_ERROR';
export const SAVE_FREE_CANCELLATION_CONFIG = '@rails/SAVE_FREE_CANCELLATION_CONFIG';
export const SAVE_RAILOFY_ZC_SHOWN = '@rails/SAVE_CGFM_GRNTEE_OR_ZC_SHOWN';
export const ACTION_RAIL_LISTING_SET_CROSS_SELL_MODAL = '@rails/ACTION_RAIL_LISTING_SET_CROSS_SELL_MODAL';
export const ACTION_RAILS_LISTING_MODIFY_SEARCH_CLICKED = '@rails/ACTION_RAILS_LISTING_MODIFY_SEARCH_CLICKED';
export const ACTION_RAILS_LISTING_FETCHING_LOCUS_ID = '@rails/ACTION_RAILS_LISTING_FETCHING_LOCUS_ID';
export const ACTION_RAILS_LISTING_FETCHING_LOCUS_ID_ERROR = '@rails/ACTION_RAILS_LISTING_FETCHING_LOCUS_ID_ERROR';
export const ACTION_RAILS_LISTING_OMNITURE = '@rails/ACTION_RAILS_LISTING_OMNITURE';
export const ACTION_RAILS_SORT_FILTER_VERSION = '@rails/ACTION_RAILS_SORT_FILTER_VERSION';
export const ACTION_INIT_RAIL_LISTING = '@rails/ACTION_INIT_RAIL_LISTING';
export const ACTION_CONFIRM_OPTIONS_ALERT = '@rails/ACTION_CONFIRM_OPTIONS_ALERT';
export const ACTION_SEAT_LOCK_BOTTOMSHEET = '@rails/ACTION_SEAT_LOCK_BOTTOMSHEET';
export const ACTION_TOGGLE_TRAIN_SCHEDULE_BOTTOM_SHEET = '@rails/ACTION_TOGGLE_TRAIN_SCHEDULE_BOTTOM_SHEET';
export const ACTION_TOGGLE_CONNECTED_TRAVEL_BOTTOM_SHEET = '@rails/ACTION_TOGGLE_CONNECTED_TRAVEL_BOTTOM_SHEET';
export const ACTION_CONNECTED_TRAVEL_BOTTOM_SHEET_DATA = '@rails/ACTION_CONNECTED_TRAVEL_BOTTOM_SHEET_DATA';
export const ACTION_SET_CONNECTED_TRAVEL_LIST = '@rails/ACTION_SET_CONNECTED_TRAVEL_LIST';
export const ACTION_TOGGLE_NEARBY_DATES_LIST = '@rails/ACTION_TOGGLE_NEARBY_DATES_LIST';
export const ACTION_UPDATE_NEARBY_DATES_SELECTED_CARD = '@rails/ACTION_UPDATE_NEARBY_DATES_SELECTED_CARD';
export const ACTION_INT_NEARBY_DATES_LIST = '@rails/ACTION_INT_NEARBY_DATES_LIST';
export const ACTION_UPDATE_NEARBY_DATES_LIST = '@rails/ACTION_UPDATE_NEARBY_DATES_LIST';
export const ACTION_NEARBY_DATES_ERROR = '@rails/ACTION_NEARBY_DATES_ERROR';
export const ACTION_UPDATE_NEARBY_DATES_TTU = '@rails/ACTION_UPDATE_NEARBY_DATES_TTU';
export const ACTION_UPDATE_QUOTA_SELECTED_OF_OTHER_DAY_TRAIN = '@rails/ACTION_UPDATE_QUOTA_SELECTED_OF_OTHER_DAY_TRAIN';
export const ACTION_UPDATE_AVAILABILITY_OF_TRAIN_FOR_ODT = '@rails/ACTION_UPDATE_AVAILABILITY_OF_TRAIN_FOR_ODT';
export const ACTION_DISPLAY_AVAIL_DEPLETION_BOTTOM_SHEET = '@rails/ACTION_DISPLAY_AVAIL_DEPLETION_BOTTOM_SHEET';
export const ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG = '@rails/ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG';

export const ALTERNATE_LISTING_IDENTIFIER = 'ALTERNATE_LISTING';
const ALTERNATE_OPTIONS_ERROR_TEXT = 'Sorry, alternate options are unavailable for this train.';
const GN_BOOKING_NOT_ALLOWED_AP = 'Booking for this train will open at 8:15 AM on MakeMyTrip. ' +
  'If you want to book it between 8 AM and 8:15 AM then we suggest you to book it on IRCTC directly.';

const TrainsEnquiryAvailabilityAPI = railsConfig.trainAvailabilityUrl;
// ===========================================================================
export const getDateFormatted = (departureDate) => {
  const dateStr = fecha.format(departureDate, 'DD MMMM YYYY dddd')
    .split(' ');
  return {
    date: dateStr[0],
    month: dateStr[1],
    year: dateStr[2],
    day: dateStr[3]
  };
};

export const setCrossSellModal = (data: boolean) => {
  return { type: ACTION_RAIL_LISTING_SET_CROSS_SELL_MODAL, data: { showCrossSellModal: data } };
};

export const railsListingBackPress = () => (dispatch, getState) => {
  const {
    railsListing: {
      showEditWidget,
      showCrossSellModal,
      displayStationChangeAlert,
      displayConfirmOptionsBottomSheet,
      displayTrainScheduleBottomSheet,
      displayConnectedTravelBottomSheet,
      displaySeatLockBottomSheet,
      displayScheduleTatkalBottomSheet,
    },
    railsLanding,
  } = getState();
  const { isFreeCancellationEnabled, originStation, destinationStation, departureDate } =
    railsLanding;

  const searchContext = buildSearchContextFromState(getState());
  logLandingEvent(
    'BACK_PRESS',
    searchContext,
    isFreeCancellationEnabled,
  );
  const actions = [
    {
      condition: showEditWidget,
      action: () => dispatch(showHideEditWidget({ showEditWidget: false, isEditClicked: false })),
    },
    { condition: showCrossSellModal, action: () => dispatch(setCrossSellModal(false)) },
    { condition: displayStationChangeAlert, action: () => dispatch(closeStationChangeAlert()) },
    {
      condition: displayConfirmOptionsBottomSheet,
      action: () => dispatch(closeConfirmOptionsBottomSheet()),
    },
    {
      condition: displayTrainScheduleBottomSheet,
      action: () => dispatch(toggleTrainScheduleBottomSheet(false)),
    },
    { condition: displaySeatLockBottomSheet, action: () => dispatch(closeSeatLockBottomSheet()) },
    {
      condition: displayConnectedTravelBottomSheet,
      action: () => dispatch(toggleConnectedTravelBottomSheet(false, false)),
    },
  ];

  for (const { condition, action } of actions) {
    if (condition) {
      action();
      return true;
    }
  }

  Actions.pop();
  return true;
};

export const railsListingOmniture = (trackingIdentifier: string) => (dispatch, getState) => {
  const {
    newListingLoadOmitureDone = false,
    confirmationProbabilityOmitureDone = false,
    noTrainsViewOmnitureDone = false,
    noDirectTrainsFoundOmnitureDone = false,
    tuneTrackerOmnitureDone = false,
  } = getState().railsListing;

  switch (trackingIdentifier) {
    case 'new-listing-load':
      if (!newListingLoadOmitureDone) {
        const { originStation: from = {}, destinationStation: to = {} } = getState().railsListing;
        trackNewListingLoad(from, to);
        dispatch({
          type: ACTION_RAILS_LISTING_OMNITURE,
          data: { newListingLoadOmitureDone: true },
        });
      }
      break;

    case 'confirmation-probability':
      const { trainBtwnStnsList, trainsList } = getState().railsListing;
      if (!confirmationProbabilityOmitureDone && !isEmpty(trainBtwnStnsList) && !isEmpty(trainsList)) {
        trackTotalCardsOnListing(trainBtwnStnsList, trainsList);
        dispatch({
          type: ACTION_RAILS_LISTING_OMNITURE,
          data: { confirmationProbabilityOmitureDone: true },
        });
      }
      break;

    case 'tune-tracker':
      const {
        originStation: from ,
        destinationStation: to ,
        departureDate: date,
      } = getState().railsListing;
      if (!tuneTrackerOmnitureDone && !isEmpty(from?.cityName) && !isEmpty(to?.cityName) && date) {
        dispatch(tuneRailsListingLoad(from, to, date));
        dispatch({
          type: ACTION_RAILS_LISTING_OMNITURE,
          data: { tuneTrackerOmnitureDone: true },
        });
      }
      break;

    case 'no-trains-view':
      if (!noTrainsViewOmnitureDone) {
        trackPageVisits('mob_rail_listing_v2_noTrainsFound_noTrainsOnOtherDates', {});
        dispatch({
          type: ACTION_RAILS_LISTING_OMNITURE,
          data: { noTrainsViewOmnitureDone: true },
        });
      }
      break;

    case 'no-direct-trains-found':
      if (!noDirectTrainsFoundOmnitureDone) {
        trackPageVisits('mob_rail_listing_v2_noTrainsFound_TrainsExistOnOtherDates', {});
        dispatch({
          type: ACTION_RAILS_LISTING_OMNITURE,
          data: { noDirectTrainsFoundOmnitureDone: true },
        });
      }
      break;
  }
};

export const setIntialLoading = (data: boolean) => (dispatch) =>{
  dispatch({
    type: ACTION_RAIL_LISTING_INTIAL_LOADING,
    data: {intialLoadingDone: data},
  });
}

const necessaryStationDetailsPresent = (station) => {
  const failed = (isEmpty(station) || isEmpty(station?.code))
  return !failed
}

//TODO:Normal listing fetch call
//Reason to disbale, just wrapped with try-catch
/* eslint-disable */
export const fetchCall = (props) => async (dispatch, getState) => {
  try {
    if(Platform.OS === 'web'){
      const {
        railsListing: { showEditWidget },
      } = getState();
      if (showEditWidget) {
        return;
      }
    }
    let origin = props?.originStation;
    let destination = props?.destinationStation;
    let date = props?.departureDate;
    if(Platform.OS === 'web'){
      date = getValidDate(date);
    }
    let locusDetail = {};
    if (
      !necessaryStationDetailsPresent(origin) ||
      !necessaryStationDetailsPresent(destination) ||
      !date
    ) {
      const {
        originStation,
        destinationStation,
        departureDate,
        locusData,
      } = await getNecessaryStationDetails(props);
      origin = originStation;
      destination = destinationStation;
      date = departureDate;
      locusDetail = locusData;
    }
    await updateEvarFromLocalStorage();
    dispatch(initState(origin, destination, date, true));
    dispatch(setIntialLoading(true));
    dispatch(initNewListing(props));
    dispatch(getNewTrainsList(origin, destination, date));
    dispatch(initAppVersion());

    const queryParams = getQueryParamsFromUrl(props?.deep_link_intent_url);

    if (
      (!isEmpty(queryParams['skywalker']) && queryParams['skywalker'] === 'true') ||
      (props?.getSkywalker && props?.getSkywalker === 'true')
    ) {
      trackNewListingFromSkyWalker();
    }

    const {
      railsLanding: {
        originStation: landingOrigin,
        destinationStation: landingDestination,
        departureDate: landingDate,
      },
    } = getState();
    if(origin?.cityName  === 'undefined'){
      getStationDetails(origin)
        .then((originDetails) => {
          const originStation = {
            ...getState()?.railsListing?.originStation,
            ...origin,
            ...originDetails,
          };
          dispatch(updateOriginStation(originStation));
          if (
            (!landingOrigin || landingOrigin?.code !== originStation?.code) &&
            necessaryStationDetailsPresent(originStation)
          ) {
            dispatch({
              type: RailsLandingActionTypes.ACTION_ON_ORIGIN_SELECTED,
              data: { ...originStation, locusCode: undefined },
            });
          }
        })
        .catch((err) => {
          return;
        });
      getStationDetails(destination)
        .then((destinationDetails) => {
          const destinationStation = {
            ...getState()?.railsListing?.destinationStation,
            ...destination,
            ...destinationDetails,
          };
          dispatch(updateDestinationStation(destinationStation));
          if (
            (!landingDestination || landingDestination?.code !== destinationStation?.code) &&
            necessaryStationDetailsPresent(destinationStation)
          ) {
            dispatch({
              type: RailsLandingActionTypes.ACTION_ON_DESTINATION_SELECTED,
              data: { ...destinationStation, locusCode: undefined },
            });
          }
        })
        .catch((err) => {
          return;
        });
      if (!landingDate && landingDate?.date.toLocaleDateString() !== date.toLocaleDateString()) {
        dispatch({
          type: RailsLandingActionTypes.ACTION_DATE_SELECTED,
          data: date,
        });
      }
   }
    //skywalker start
    try {
      const skyWalkerData = {
        fromCity: origin?.code,
        toCity: destination?.code,
        fromDateTime: getFormattedDateFromDate(
          date,
          twentyFourHourDateTimeFormat,
        ),
      };

      skywalkerSearchConnector(skyWalkerData, 'listing');

      //New connector

      const searchContext={
        fromCity: origin?.code,
        fromCityName :origin?.cityName,
        fromStationName: origin?.stationName,
        toCity: destination?.code,
        toCityName: destination?.cityName,
        toStationName: destination?.stationName,
        fromDateTime: date
      };
      SearchConnector(searchContext,'listing');

    } catch (e) {
      console.log('Skywalker error: ', e);
    }
    //skywalker end
    if (Platform.OS === 'web') {
      const payload = {
        source: origin?.code,
        sourceStation: origin?.cityName,
        destination: destination?.code,
        destinationStation: destination?.cityName,
        doj: date,
      };
      pushListingIntoGtm(payload);
    }
  } catch (error) {
    const errorData = {
      catchedErrorMesage: error,
      source: 'RAILS_LISTING_ACTION@fetchCall'
    };
    logErrorToFirebase(errorData);
  }
};
/* eslint-enable */

let prevUrlListingInit;
export const initState = (originStation, destinationStation, departureDate, loading) => (dispatch, getState) => {
  if (Platform.OS === 'web') {
    if (prevUrlListingInit === window.location.href) {
      return;
    } else {
      prevUrlListingInit = window.location.href;
    }
  }
  let { railsListing: { isLoading } } = getState();
  if (loading !== undefined) {
    isLoading = loading;
  }
  if (originStation?.code && destinationStation?.code && departureDate) {
    setDataInStorage(SEARCH_CONTEXT,{
      source: originStation.code,
      destination: destinationStation.code,
      doj: fecha.format(departureDate, 'YYYYMMDD')
    });
  }
  dispatch({
    type: ACTION_RAILS_LISTING_INIT_STATE,
    data: {
      originStation,
      destinationStation,
      departureDate,
      isLoading,
    }
  });
};
export const onOriginClicked = (dispatch, getState) => {
  const { railsListing: { originStation, destinationStation,departureDate } } = getState();
  Actions.railsCityPicker({
    selectedCity: originStation,
    pairedCity: destinationStation,
    inputCitySelected: INPUT_CITY_SELECTED.source,
    actionType: ACTION_RAILS_LISTING_EDIT_ORIGIN
  });
};

export const onDestinationClicked = (dispatch, getState) => {
  const { railsListing: { originStation, destinationStation,departureDate } } = getState();
  Actions.railsCityPicker({
    selectedCity: destinationStation,
    pairedCity: originStation,
    inputCitySelected: INPUT_CITY_SELECTED.destination,
    actionType: ACTION_RAILS_LISTING_EDIT_DESTINATION
  });
};

export const showHideEditWidget = (data) => (dispatch) => {
  dispatch({
    type: ACTION_RAIL_LISTING_SHOW_HIDE_EDIT_WIDGET,
    data
  })
}

export const showIsLoading = (data) => (dispatch) => {
  dispatch({
    type: ACTION_RAIL_LISTING_SHOW_LOADING,
    data
  })
}

export const setLocusIdFromStationDetailsError = (locusIdFromStationDetailsError: boolean) => ({
  type: ACTION_RAILS_LISTING_FETCHING_LOCUS_ID_ERROR,
  data: locusIdFromStationDetailsError,
});

export const setFetchingLocusId = (fetchingLocusId: boolean) => ({
  type: ACTION_RAILS_LISTING_FETCHING_LOCUS_ID,
  data: fetchingLocusId,
});

export const railsListingSearchParamsChanged = (noResolving) => async (dispatch, getState) => {
  if (!noResolving) {
    const {
      railsListing: { originStation, destinationStation, departureDate },
    } = getState();
    const [fromLocusCode, toLocusCode] = [originStation?.locusCode, destinationStation?.locusCode];
    let origin: any = {},
      destination: any = {};
    if (isEmpty(fromLocusCode) || isEmpty(toLocusCode)) {
      const [from_station_code, to_station_code] = [originStation?.code, destinationStation?.code];
      if (!isEmpty(from_station_code) && !isEmpty(to_station_code)) {
        dispatch(setFetchingLocusId(true));
        const retryLocus = async (retry: number) => {
          getLocusIdFromStationDetails({
            from_station_code,
            to_station_code,
          })
            .then((locusData) => {
              const { railsListing: {
                originStation,
                destinationStation
              }} = getState();
              origin.locusCode = locusData?.fromLocusCode;
              origin.locusType = locusData?.sourceLocusType;
              origin.locusV2Id = locusData?.sourceLocusV2Id;
              origin.locusV2Type = locusData?.sourceLocusV2Type;
              destination.locusCode = locusData?.toLocusCode;
              destination.locusType = locusData?.destinationLocusType;
              destination.locusV2Id = locusData?.destinationLocusV2Id;
              destination.locusV2Type = locusData?.destinationLocusV2Type;
              dispatch(
                initState(
                  { ...originStation, ...origin },
                  { ...destinationStation, ...destination },
                  departureDate,
                  getState()?.railsListing?.isLoading,
                ),
              );
              dispatch(setLocusIdFromStationDetailsError(false));
              dispatch(setFetchingLocusId(false));
            })
            .catch((err) => {
              if (retry === 0) {
                dispatch(setLocusIdFromStationDetailsError(true));
                dispatch(setFetchingLocusId(false));
              } else {
                retryLocus(retry - 1);
              }
            });
        };
        retryLocus(2);
      }
    }
  }
  if(Platform.OS === 'web'){
      const { originStation, destinationStation, departureDate } = getState().railsListing;
      updateListingQueryParams(originStation, destinationStation, departureDate);
  }
  dispatch({
    type: ACTION_RAIL_LISTING_SEARCH_PARAMS_CHANGED,
    data: { searchParamsChanged: true },
  });
};

export const setDepartureDate = date => (dispatch) => {
  dispatch({
    type: ACTION_DATE_SELECTED_LISTING,
    data: date
  });
};
export const onDateClick = (dispatch, getState) => {
  const { railsListing: { departureDate } } = getState();
  Actions.railsCalendar({ selectedDate: departureDate, fromPage: LISTING_PAGE_CONST });
};
export const onSwapClicked = () => ({
  type: ACTION_SWAP_SEARCH_LISTING,
  data: null
});

export const updateOriginStation = (originStation) => (dispatch) => {
  dispatch({
    type: ACTION_RAILS_LISTING_UPDATE_ORIGIN,
    data: {
      originStation
    }
  });
}

export const updateDestinationStation = (destinationStation) => (dispatch) => {
  dispatch({
    type: ACTION_RAILS_LISTING_UPDATE_DESTINATION,
    data: {
      destinationStation
    }
  });
}

export const skipUniversalWidgetParam = () => (dispatch) => {
  dispatch({
    type: ACTION_SKIP_UNIVERAL_WIDGET_URL
  })
}

export const onSortTrainClicked = selectedSortParam => (dispatch, getState) => {
  const { railsListing: { trainsList } } = getState();
  trackNewListingSortEvent(`mob_rail_listing_v2_sort_${selectedSortParam.value}_selected`);
  // tracking
  fireOmnitureEventsNew('Sort_Apply');
  dispatch({
    type: ACTION_SET_LIST_SORTED_ORDER,
    data: {
      trainsList: sortTrainsList(trainsList, selectedSortParam),
      selectedSortParam
    }
  });
};

export const sortTrainsList = (trainsList, selectedSortParam) => {
  interface Train {
    duration: number;
    departureDateAndTime: Date;
    clusterTrain: boolean;
  }
  switch (selectedSortParam.id) {
    case SortType.DurationFastest.id: {
      return sortBy(trainsList, [train => train.duration]);
    }
    case SortType.DepartureEarliest.id: {
      const pokusVal = getRailsListingSortingLogic();
      if (pokusVal === '5') {
        const { irctcTrains, clusterTrains } = (trainsList || []).reduce(
          (acc: { irctcTrains: Train[]; clusterTrains: Train[] }, train: Train) => {
            const sortedTrain = sortBy([train], [(train) => train.departureDateAndTime]);
            if (train.clusterTrain) {
              acc.clusterTrains.push(...sortedTrain);
            } else {
              acc.irctcTrains.push(...sortedTrain);
            }
            return acc;
          },
          { irctcTrains: [], clusterTrains: [] },
        );
        return [...irctcTrains, ...clusterTrains];
      }
      return sortBy(trainsList, [train => train.departureDateAndTime]);
    }
    case SortType.DepartureLatest.id: {
      return reverse(sortBy(trainsList, [train => train.departureDateAndTime]));
    }
    case SortType.ArrivalEarliest.id: {
      return sortBy(trainsList, [train => train.arrivalDateAndTime]);
    }
    case SortType.ArrivalLatest.id: {
      return reverse(sortBy(trainsList, [train => train.arrivalDateAndTime]));
    }
    default: {
      return sortBy(trainsList, [train => train.defaultSortedPriority]);
    }
  }
};

export const buildTrainList = trainsList => (dispatch, getState) => {
  const { railsListing: { originStation, destinationStation, departureDate, selectedSortParam } } = getState();
  if (isEmpty(trainsList)) {
    dispatch({
      type: ACTION_RAILS_LISTING_ERROR,
      data: {
        errorMessage: 'No trains found on this route',
        errorSubtitle: 'Please try searching for other nearby cities',
        errorFlag: true,
        recommendedMessage: '',
        recommendedList: [],
        noTrainFound: true,
        trainsList: [],
        minPriceDetails: {},
        minDuration: null,
      }
    });
    return [];
  }
  const availDepletionInitialIndex = trainsList?.findIndex(
    (train) => !isEmpty(train?.availabilityDepletion),
  );
  return sortTrainsList(trainsList.map((train,defaultSortedPriority) => {
    const departureDateAndTime = getDepartureDateAndTime(train, departureDate);
    const arrivalDateAndTime = addMinutes(departureDateAndTime, train.duration);
    const stationChangeSign = getImageSign(originStation, destinationStation, train);
    const cnfOptions = { loading: true, text: null };
    const clusterTrain = train.clusterTrain || false;
    return ({
      ...train,
      avlClasses: train.avlClasses,
      departureDateAndTime,
      arrivalDateAndTime,
      stationChangeSign,
      cnfOptions,
      clusterTrain,
      defaultSortedPriority,
      ...((defaultSortedPriority === availDepletionInitialIndex) && {showAvailDepletIntro: true}),
    });
  }), selectedSortParam);
};


export const buildOtherDayTrainsList = trainsList => (dispatch, getState) => {
  const { railsListing: { originStation, destinationStation, departureDate, selectedSortParam } } = getState();

  return sortTrainsList(
    trainsList?.map((train, defaultSortedPriority) => {
    const dateString = train?.possibleDates?.[0]
    const deptDate = new Date(`${dateString.substring(0, 4)}-${dateString.substring(4, 6)}-${dateString.substring(6, 8)}`);
    const departureDateAndTime = getDepartureDateAndTime(train, deptDate);
    const arrivalDateAndTime = addMinutes(departureDateAndTime, train.duration);
    const stationChangeSign = getImageSign(originStation, destinationStation, train);
    const cnfOptions = { loading: true, text: null };
    const clusterTrain = train.clusterTrain || false;
    return ({
      ...train,
      avlClasses: train.avlClasses,
      departureDateAndTime,
      arrivalDateAndTime,
      stationChangeSign,
      cnfOptions,
      clusterTrain,
      defaultSortedPriority
    });
  }), selectedSortParam);
};

const tatkaalTimings = (quotaCode, departureDate) => {
  const date = new Date();
  const hour = date.getHours();
  const minutes = date.getMinutes();
  const differenceinDays = diffDays(departureDate, date);

  if (quotaCode === 'GN' || quotaCode === 'LD') {
    if ((hour === 10 && minutes >= 58) || (hour === 11 && minutes < 15)) {
      return {
        error: true,
        errorMessage: 'General quota booking unavailable between 11:00 - 11:15 AM.'
      };
    }
  }
  if (quotaCode === 'TQ' && hour === 10 && minutes <= 15) {
    return {
      error: true,
      errorMessage: 'Tatkal booking unavailable between 10:00 - 10:15 AM'
    };
  }
  if (quotaCode === 'TQ' && ((hour === 10 && minutes >= 58) || (hour === 11 && minutes < 15))) {
    return {
      error: true,
      errorMessage: 'Tatkal booking unavailable between 11:00 - 11:15 AM'
    };
  }
  if (differenceinDays === 119 && hour === 8 && minutes <= 15) {
    return {
      error: true,
      errorMessage: GN_BOOKING_NOT_ALLOWED_AP
    };
  }
  return {
    error: false,
    errorMessage: ''
  };
};

interface AvailabilityResponseRequest {
  reservationChoice: typeof NO_RESERVATION_CHOICE_CODE;
  source: string;
  destination: string;
  class: string; // enum
  quota: string; // enum
  doj: string; //  "20210522"
  trainNumber: string; //  "02138"
  moreThanOneDay: boolean;
  zcEnable?: boolean,
  railsConfirmationGuaranteeOption?: number;
}
export const getAvailabilityResponse = async (className, trainInfo, quotaCode, departureDate, freeCancellationConfig, confirmationGuaranteeConfig,moreThanOneDay=false) => {

  try {
    // removing Tatkal timing check from frontend
    // const {error, errorMessage} = tatkaalTimings(quotaCode, departureDate);
    // if (error) {
    //   return {errorMessage};
    // }
    const { frmStnCode, toStnCode, trainNumber, possibleDates, odt } = trainInfo;

    const searchDate =  fecha.format(departureDate, 'YYYYMMDD');;
    const departDate = odt ? possibleDates?.[0] : searchDate;
    const requestBody: AvailabilityResponseRequest = {
      reservationChoice: NO_RESERVATION_CHOICE_CODE,
      source: frmStnCode,
      destination: toStnCode,
      class: className,
      quota: quotaCode,
      doj: departDate,
      trainNumber,
      moreThanOneDay: moreThanOneDay
    };
    if (freeCancellationConfig) {
      requestBody.zcEnable = freeCancellationConfig.freeCancellationEnabled || false;
    }
    if (confirmationGuaranteeConfig) {
      requestBody.railsConfirmationGuaranteeOption = confirmationGuaranteeConfig.railsConfirmationGuaranteeOption
    }

    const res = await fetch2(TrainsEnquiryAvailabilityAPI, {
      method: 'POST',
      headers: getDefaultPostHeaders(),
      body: JSON.stringify(requestBody),
    });
    const response = await res.json();
    return response.errorMessage ? { errorMessage: response.errorMessage } : response;
  } catch (e) {
    console.log('error in fillCreateAccountData', e);
    return {
      errorMessage: _label("something_went_wrong_try_again_later") + " Error Code: " + e?.errorCode
    };
  }
};

export const setNewTbsAvailability =
  (response, className, quota, trainInfo, lastUpdatedOn = _label('updated_few_minutes_ago')) =>
  (dispatch) => {
  const { totalFare, avlDayList, baseFare } = response;
  const [availability] = avlDayList;
  const {
      availablityDate,
      availablityStatus,
      availablityType,
      reason,
      reasonType,
      prettyPrintingAvailablityStatus,
      confirmationGuaranteeText,
      freeCancellationText,
      availabilityDepletion = null,
  } = availability;
  const newTbsAvailability = {
    availablityDate,
    availablityStatus,
    prettyPrintingAvailablityStatus,
    availablityType,
    reason,
    reasonType,
    wlType: '',
    currentBkgFlag: 'D',
    className,
    quota,
    totalFare,
    baseFare,
      confirmationGuaranteeText,
    freeCancellationText,
      lastUpdatedOn: availability?.lastUpdatedOn ?? lastUpdatedOn,
      availabilityDepletion,
  };

  dispatch({
    type: ACTION_UPDATE_TBS_AVAILABILITY,
    data: {
      newTbsAvailability,
      trainInfo
    },
  });
};

export const getAvailabilityCardTrackingData =
  (className, trainData, quotaCode, availabilityItem) => {
    const { trainName, trainNumber } = trainData;
    const { availablityStatus } = availabilityItem;
    return `${trainName}|${trainNumber}|${quotaCode}|${className}|${availablityStatus}|NA`;
  };

export const getUpdateTrackingData = (className, trainData, quotaCode) => {
  const { trainName, trainNumber } = trainData;
  return `${trainName}|${trainNumber}|${quotaCode}|${className}|NA|NA`;
};

export const getViewDetailsTrackingData = (trainData) => {
  const { trainName, trainNumber } = trainData;
  return `${trainName}|${trainNumber}|NA|NA|NA|NA`;
};

export const getSeatExpandedClickData =
  (className, quotaCode, selectedDateObject, trainData) => {
    const { trainName, trainNumber } = trainData;
    const { availablityStatus } = selectedDateObject;
    return `${trainName}|${trainNumber}|${quotaCode}|${className}|${availablityStatus}|NA`;
  };

export const updateCardClicked = (className, trainInfo, quotaCode) =>
  async (dispatch, getState) => {
    trackNewListingEvent(
      'mob_rail_listing_v2_tap_to_update_clicked',
      getUpdateTrackingData(className, trainInfo, quotaCode)
    );

    dispatch({
      type: '@rails/TBS_AVAILABILITY_CARD_LOADING',
      data: {
        trainInfo,
        quotaCode,
        className,
        isLoading: true
      }
    });
    try {
      const { railsListing: { departureDate, freeCancellationConfig, confirmationGuaranteeConfig } } = getState();
      const response =
        await getAvailabilityResponse(className, trainInfo, quotaCode, departureDate, freeCancellationConfig, confirmationGuaranteeConfig,true);
      if (!isEmpty(response.errorMessage)) {
        trackClickEventProp61(RAILS_LISTING,`rails_ttu_${response.errorMessage}`);
      dispatch({
        type: ACTION_STATION_CHANGE_ALERT,
        data: { settingListingDataForTravellers: false },
      });
      showShortToast(_label(response.errorMessage));

      if (response?.errorMessage?.includes(TRAIN_OUTSIDE_RESERVATION_WINDOW)) {
        dispatch(setNewTbsAvailability(dummyArpResponse, className, quotaCode, trainInfo));
      }
        return;
      }
      const { avlDayList = null } = response;
      if (avlDayList && avlDayList?.length !== 0) {
        const { availablityStatus } = avlDayList[0];
        trackClickEventProp61(RAILS_LISTING, `rails_ttu_${availablityStatus}`)
      }
      const { travelplexChatConfig, travelplexTickers } = response?.travelplexConfig || {};
      dispatch({
        type: ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
        data: {
          travelplexChatConfig,
          travelplexTickers,
        },
      });
      dispatch(setNewTbsAvailability(response, className, quotaCode, trainInfo));
    } catch (e) {
      console.log('error in updateCardClick', e);
      trackClickEventProp61(RAILS_LISTING,`rails_ttu_something_went_wrong_try_again_later`)
      showShortToast(_label("something_went_wrong_try_again_later") + " Error Code: " + e?.errorCode);
    } finally {
      dispatch({
        type: '@rails/TBS_AVAILABILITY_CARD_LOADING',
        data: {
          trainInfo,
          quotaCode,
          className,
          isLoading: false
        }
      });
      const isNewNearbyDates = getNearbyDatesNew();
      if(isNewNearbyDates){
        dispatch(nearbyDatesCardClick(trainInfo, className, quotaCode));
        dispatch(toggleNearbyDatesList(true, trainInfo.trainNumber, className, quotaCode));
      }
    }
  };

export const changeFiltersClicked = () => (dispatch) => {
  dispatch(onFilterIconClick);
};

export const clearAllFiltersClickedInListing = () => (dispatch) => {
  dispatch(onClearAllFiltersClickedInListing());
};

const getStationChangeAlertBottomsheetVal = (clusterTrain: boolean, stationChangeSign: string) => {
  let showStationChangeAlert = clusterTrain;
  if(!clusterTrain){
    showStationChangeAlert =  getClusterBottomSheetForStationChangeAlert();
  }
  const showBottomSheet = (showStationChangeAlert && !(stationChangeSign === StationChangeSignType.S0D0.code));
  return showBottomSheet;
}

export const onAvailabilityDateClicked =
  (selectedDate: FutureSelectedDateData, trainData: FutureSelectedTrain) =>
  (dispatch: any, getState: any) => {
    const { trainNumber, avlClasses } = trainData;
  const updateTrainData = updateTimeInfoInSelectedTrain(trainData, selectedDate.availablityDate);
    const {
      railsListing: { trainsListObject },
    } = getState();
  const { availabilityResponse: response, selectedClassType, selectedQuota } =
    trainsListObject[trainNumber];
  const { avlDayList, originalAvlDayList } = getAvlDayList(response, trainData);
  const selectedAvlStatus = getDefaultAvlStatus(avlDayList, selectedDate.availablityDate);
  const selectedBookingDate = selectedDate;
  trackNewListingDateChangeEvent(
    'mob_rail_listing_v2_expanded_card_clicked',
    getSeatExpandedClickData(selectedClassType, selectedQuota?.code, selectedDate, trainsListObject[trainNumber]),
    selectedDate
  );
  if (!isBookNowEnabled(selectedBookingDate)) {
    showShortToast(_label("booking_not_available_for_this_train"));
    return;
  }
    const {
      insuranceCharge,
      totalCollectibleAmount,
      totalFare,
      baseFare,
      applicableFoodTypes,
      travelplexConfig,
    } = response;
    const { travelplexChatConfig, travelplexTickers } = travelplexConfig || {};
  const { stationChangeSign, clusterTrain } = trainData;

  const displayStationChangeAlert = getStationChangeAlertBottomsheetVal(clusterTrain, stationChangeSign);
  const dispatchData = {
    applicableFoodTypes,
    selectedTrainInfo: updateTrainData,
    selectedClassType,
    allAvailableClasses: avlClasses,
    selectedQuota,
    selectedBookingDate,
    originalSelectedBookingDate: originalAvlDayList[0],
      selectedAvlStatus,
      avlDayList,
      ...response.bkgCfg,
    insuranceCharge,
    totalCollectibleAmount,
    displayStationChangeAlert,
    totalFare,
      baseFare,
      travelplexChatConfig,
      travelplexTickers,
  };

  const railofyZcShown = {
    railofyShown: Boolean(selectedDate?.confirmationGuaranteeText),
    zcShown: Boolean(selectedDate.freeCancellationText),
  };

  dispatch(saveRailofyZcShown(railofyZcShown));
  dispatch({
    type: ACTION_SET_DATA_FOR_TRAVELERS_PAGE,
    data: dispatchData
  });
  if (!displayStationChangeAlert) {
    dispatch(goToTravelersPage);
  }
};

export const availabilityCardClicked = (className: string, trainInfo, quotaCode: string, isNext = false) =>
  async (dispatch, getState) => {
    try {
      const isAlternateAvailabilyCard = className.includes(ALTERNATE_LISTING_IDENTIFIER);
      const { avlClasses, departureDateAndTime } = trainInfo;
      const { stationChangeSign, clusterTrain } = trainInfo;
      const displayStationChangeAlert = getStationChangeAlertBottomsheetVal(clusterTrain, stationChangeSign)
        && !(trainInfo.boardingStation && trainInfo.droppingStation);
      const displayConfirmOptionsBottomSheet = getRailsRouteExtenstionBottomsheet()
        && isAlternateAvailabilyCard && getRailsRouteExtenstionV2();

      let selectedTrainClassQuotaAvailibilty = trainInfo.tbsAvailability.filter(x => x.quota == quotaCode && x.className == className)
      let isBookingAllowed = selectedTrainClassQuotaAvailibilty.length > 0 && !isEmpty(selectedTrainClassQuotaAvailibilty[0].availablityType)
        && selectedTrainClassQuotaAvailibilty[0].availablityType != AvailabilityStatusValues.NO_ROOM.value
        && !selectedTrainClassQuotaAvailibilty[0].availablityType.startsWith(AvailabilityStatusValues.DEPARTED.value);
      if (isAlternateAvailabilyCard) {
        const alternateAvlClass = className.split('-')[0];
        const alternateAvailabilityList = getState()?.railsListing?.alternateAvailabilityResponse?.alternateAvailabilityList || [];
        const alternateAvlItem = alternateAvailabilityList.find((avl: any) => avl?.trainNumber === trainInfo?.trainNumber);
        const alternateClassAvlList = alternateAvlItem.classAvailabilityList;
        const alternateClassAvlItem = alternateClassAvlList.find((acvi: any) => {
          const acviClassName = acvi?.tbsAvailability?.className || acvi?.tbsAvailability?.classType;
          return (acviClassName === alternateAvlClass && acvi?.tbsAvailability?.quota === quotaCode);
        });
        const alterAvlType = alternateClassAvlItem?.tbsAvailability?.availablityType;
        const isBookingNotAllowed = alterAvlType === AvailabilityStatusValues.NO_ROOM.value
          || alterAvlType === AvailabilityStatusValues.DEPARTED.value
          || alterAvlType.startsWith(AvailabilityStatusValues.DEPARTED.value);
        isBookingAllowed = !isBookingNotAllowed;
        dispatch(saveRailofyZcShown({ railofyShown: false, zcShown: false }));
      }

      if (!isAlternateAvailabilyCard) {
        removeEventFromEvar47or97Variable(
          `${RAIL_EVENTS.LISTING.RAIL_LISTING_CONFIRMED_OPTIONS_CLICKED}`,
        );
      }

      if (!isBookingAllowed) {
        trackClickEventProp61(RAILS_LISTING,"rail_card_e_booking_not_available_for_this_train")
        showShortToast(_label("booking_not_available_for_this_train"));
        return;
      }


      if(displayConfirmOptionsBottomSheet && !isNext) {
        const selectedQuota: QuotaTypeInterface = getQuota(quotaCode);
        dispatch({
          type: ACTION_CONFIRM_OPTIONS_ALERT,
          data: {
            displayConfirmOptionsBottomSheet,
            selectedClassType: className,
            selectedQuota,
            selectedTrainInfo: trainInfo,
            isNearbyConfirmedOption: false,
          }
        });
        return;
      }

      if (displayStationChangeAlert && !isNext) {
        const selectedQuota: QuotaTypeInterface = getQuota(quotaCode);
        dispatch({
          type: ACTION_STATION_CHANGE_ALERT,
          data: {
            displayStationChangeAlert,
            selectedClassType: className,
            selectedQuota,
            selectedTrainInfo: trainInfo
          }
        });
        return;
      } else {
        dispatch({
          type: ACTION_STATION_CHANGE_ALERT,
          data: { settingListingDataForTravellers: true }
        });
      }
      const formattedClassName = isAlternateAvailabilyCard ? className.split('-')[0] : className;
      const {
        railsListing: { freeCancellationConfig, confirmationGuaranteeConfig },
      } = getState();

      const response =
        await getAvailabilityResponse(formattedClassName, trainInfo, quotaCode, departureDateAndTime, freeCancellationConfig, confirmationGuaranteeConfig, false);
      if (!isEmpty(response.errorMessage)) {
        trackClickEventProp61(RAILS_LISTING,`rail_card_e_${response.errorMessage}`)
        showShortToast(response.errorMessage);
        dispatch({
          type: ACTION_STATION_CHANGE_ALERT,
          data: { settingListingDataForTravellers: false }
        });
        return;
      } else {
        dispatch(
          setNewTbsAvailability(
            response,
            className,
            quotaCode,
            trainInfo,
            selectedTrainClassQuotaAvailibilty[0]?.lastUpdatedOn,
          ),
        );
      }
      const { avlDayList, originalAvlDayList } = getAvlDayList(response, trainInfo);
      const formattedDate = fecha.format(departureDateAndTime, 'DD-MM-YYYY');
      const selectedAvlStatus = getDefaultAvlStatus(avlDayList, formattedDate);
      const selectedBookingDate = avlDayList[0];
      const { travelplexChatConfig, travelplexTickers } = response?.travelplexConfig || {};
      const { insuranceCharge, totalCollectibleAmount, totalFare, baseFare, applicableFoodTypes } = response;
      if (!isBookNowEnabled(selectedBookingDate)) {
        dispatch({
          type: ACTION_STATION_CHANGE_ALERT,
          data: { settingListingDataForTravellers: false },
        });
        trackClickEventProp61(RAILS_LISTING,"rail_card_e_booking_not_available_for_this_train")
        showShortToast(_label("booking_not_available_for_this_train"));
        return;
      }
      const {railsLanding , railsListing} = getState();
      const selectedQuota: QuotaTypeInterface = getQuota(quotaCode);
      const dispatchData = {
        applicableFoodTypes,
        selectedClassType: formattedClassName,
        allAvailableClasses: avlClasses,
        selectedQuota,
        selectedBookingDate,
        originalSelectedBookingDate: originalAvlDayList[0],
        selectedAvlStatus,
        avlDayList,
        ...response.bkgCfg,
        travelAdvisoryDetails: response.travelAdvisoryDetails,
        insuranceCharge,
        totalCollectibleAmount,
        totalFare,
        baseFare,
        selectedTrainInfo: trainInfo,
        settingListingDataForTravellers: false,
        travelplexChatConfig,
        travelplexTickers,
      };
      dispatch({
        type: ACTION_SET_DATA_FOR_TRAVELERS_PAGE,
        data: dispatchData
      });
      trackClickEventProp61(RAILS_LISTING,`rail_card_${selectedAvlStatus}`)
      dispatch(goToTravelersPage);
      const selectedClass = { selectedClassType : className, selectedQuota : quotaCode };
      trackPdtListingLoad(
        getListingPagePdt(trainInfo, railsLanding, railsListing, selectedClass),
        RAIL_AVAILABILITY_CARD_DATA_TYPE,
        null,
      );
      if (!isEmpty(response?.avlDayList?.[0]?.availabilityDepletion)) {
        switch(getRailsAvailDepletion()) {
          case 1:
            updateEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V1);
            break;
          case 2:
            updateEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V2);
            break;
          default:
            break;
        }
      } else {
        removeEventFromEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V1);
        removeEventFromEvar47or97Variable(RAIL_EVENTS.TRAVELLER.RAILS_AVAIL_DEPLETION_V2);
      }
    } catch (e) {
      trackClickEventProp61(RAILS_LISTING,"rail_card_e_wrong_date_format")
      dispatch({
        type: ACTION_STATION_CHANGE_ALERT,
        data: { settingListingDataForTravellers: false },
      });
      console.log('wrong date format', e);
      const errorData = {
        catchedErrorMesage: e?.message,
        railsFromCode: trainInfo?.frmStnCode,
        railsFromStation: trainInfo?.frmStnName,
        railsToCode: trainInfo?.toStnCode,
        railsToStation: trainInfo?.toStnName,
        trainNumber: trainInfo?.trainNumber,
        railsRawDeptDate: trainInfo?.departureDateAndTime,
        railsRawArrivalDate: trainInfo?.arrivalDateAndTime,
      };
      logErrorToFirebase(errorData);
      logGrafanaErrorMetrics(
        PAGE.LISTING_V2,
        ENTITY_TYPE.API,
        ENTITY.SEARCH_API,
        JSON.stringify(errorData),
        3400,
      );
    }
  };

export const getDepartureDateAndTime = (currentTrain, departureDate) => {
  try {
    const hoursAndMinutes = fecha.parse(currentTrain.departureTime, 'HH:mm');
    const hours = hoursAndMinutes.getHours();
    const minutes = hoursAndMinutes.getMinutes();
    const departureDateAndTime = new Date(departureDate.getTime());
    departureDateAndTime.setHours(hours);
    departureDateAndTime.setMinutes(minutes);
    return departureDateAndTime;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const getQuotaClassRate = (quotaList, classList) => quotaList.reduce((acc, item) => {
  const classItem = classList?.reduce((classAcc, classType) => ({
    ...classAcc,
    [classType]: { rate: '' }
  }), {});
  return {
    ...acc,
    [item]: classItem
  };
}, {});

export const getOrderedQuotaList = (quotaList) => {
  if (isEmpty(quotaList)) {
    return [];
  }
  const ladiesQuotaIndex = quotaList.indexOf(QuotaType.LD.code);
  if (ladiesQuotaIndex === -1) {
    return quotaList;
  }
  const ldArray = quotaList.splice(ladiesQuotaIndex, 1);
  return [...quotaList, ...ldArray];
};

export const promiseTimeout = (ms, promise) => {
  // Create a promise that rejects in <ms> milliseconds
  const timeout = new Promise((resolve, reject) => {
    const id = setTimeout(() => {
      clearTimeout(id);
      reject(new Error('timed out'));
    }, ms);
  });

  // Returns a race between our timeout and the passed in promise
  return Promise.race([
    promise,
    timeout
  ]);
};

export const getNewVoucherClick = async (dispatch) => {
  try {
    dispatch({
      type: ACTION_SET_VOUCHER_OBJECT,
      data: { voucherLoading: true }
    });
    const res = await fetch2(railsConfig.generateVoucher, {
      method: 'POST'
    });
    const voucherObject = await res.json();
    if (!isEmpty(voucherObject.error)) {
      throw new Error('api errored out');
    }
    dispatch({
      type: ACTION_SET_VOUCHER_OBJECT,
      data: {
        voucherObject: {
          ...voucherObject,
          voucherStatus: voucherState.ACTIVE
        },
        voucherLoading: false
      }
    });
    trackNewListingClickEvent('mob_rail_listing_v2_tap_to_win_clicked');
  } catch (e) {
    console.log('error is', e);
    showShortToast(_label("something_went_wrong_try_again_later") + " Error Code: " + e?.errorCode );
    Actions.pop();
  }
};

export const setAlternateAvailabilityAction = (showTrainRouteIcon: any, originStation: any, destinationStation: any, departureDate: any, trainNumber = null, openCnfOptionsPage=false, pnrNumber = null) => async (dispatch: any, getState) => {
  try {
    const { data, status } = await getAlternateAvailabilityResponse(
      originStation.code,
      destinationStation.code,
      departureDate
    );
    const {
      railsListing: {
        alternateAvailabilityResponse: prevAlternateAvailabilityResponse
      }
    } = getState();

    let alternateAvailabilityResponse = null;
    if (trainNumber) {
      alternateAvailabilityResponse = {
        ...data,
        alternateAvailabilityList:
          data.alternateAvailabilityList.filter(item => item.trainNumber === trainNumber)
      };
      if (isEmpty(alternateAvailabilityResponse.alternateAvailabilityList)) {
        showShortToast(ALTERNATE_OPTIONS_ERROR_TEXT);
        return;
      }
    } else {
      alternateAvailabilityResponse = data;
    }
    if (status === 200) {
      dispatch({
        type: ACTION_SET_ALTERNATE_AVAILABILTY_LIST,
        data: {
          alternateAvailabilityResponse: {
            ...prevAlternateAvailabilityResponse,
            ...alternateAvailabilityResponse,
          }
        }
      });
      if(openCnfOptionsPage) {
      Actions.railsAlternateListing({
        alternateAvailabilityResponse,
        trainNumber,
        pnrNumber,
        showTrainRouteIcon
      });
      }
    } else {
      showShortToast(data.errorDetails.errorMessage);
    }
  } catch (e) {
    console.log('error in setAkternateAv alability', e);
    showShortToast(ALTERNATE_OPTIONS_ERROR_TEXT + " Error Code: " + e?.errorCode );
  }
}

export const setAlternateAvailability = async (showTrainRouteIcon, originStation, destinationStation, departureDate, trainNumber = null, pnrNumber = null) => {
  try {
    const { data, status } = await getAlternateAvailabilityResponse(
      originStation.code,
      destinationStation.code,
      departureDate
    );

    let alternateAvailabilityResponse = null;
    if (trainNumber) {
      alternateAvailabilityResponse = {
        ...data,
        alternateAvailabilityList:
          data.alternateAvailabilityList.filter(item => item.trainNumber === trainNumber)
      };
      if (isEmpty(alternateAvailabilityResponse.alternateAvailabilityList)) {
        showShortToast(ALTERNATE_OPTIONS_ERROR_TEXT);
        return;
      }
    } else {
      alternateAvailabilityResponse = data;
    }
    if (status === 200) {
      Actions.railsAlternateListing({
        alternateAvailabilityResponse,
        trainNumber,
        pnrNumber,
        showTrainRouteIcon
      });
    } else {
      showShortToast(data.errorDetails.errorMessage);
    }
  } catch (e) {
    showShortToast(ALTERNATE_OPTIONS_ERROR_TEXT + " Error Code: " + e?.errorCode );
  }
};

export const getConfirmOptions = (from, to, date) => async (dispatch) => {
  try {
    const res = await fetch2(railsConfig.confirmedOptions, {
      method: 'POST',
      body: JSON.stringify({
        source: from.code,
        destination: to.code,
        doj: fecha.format(date, 'YYYYMMDD')
      })
    });
    const data = await res.json();
    if (res.status === 200) {
      dispatch({
        type: ACTION_SET_CONFIRM_OPTIONS,
        data
      });
    } else {
      dispatch({
        type: ACTION_SET_CONFIRM_OPTIONS,
        data: null
      });
    }
  } catch (e) {
    dispatch({
      type: ACTION_SET_CONFIRM_OPTIONS,
      data: null
    });
  }
};

export const refreshListingPage = () => async (dispatch, getState) => {
  dispatch(showIsLoading(true));
  const { railsListing: { originStation, destinationStation, departureDate, } } = getState();
  //skywalker start
  try {
    const skyWalkerData = {
      fromCity: originStation.code,
      toCity: destinationStation.code,
      fromDateTime: fecha.format(departureDate,'DD-MM-YYYY HH:MM:ss')
    }
    skywalkerSearchConnector(skyWalkerData, 'listing');
  } catch (e) {
    console.log("Skywalker error: ", e)
  }
  //skywalker end
  dispatch(getNewTrainsList(originStation, destinationStation, departureDate));
};

interface railsListingShowErrorScreenInterface {
  listingErrorMessage: string,
  listingErrorSubtitle: string,
  listingErrorCode?: string,
  recommendedMessage?: string,
  recommendedList?: any[],
  noTrainFound?: boolean,
}
export const railsListingShowErrorScreen = ({
  listingErrorMessage,
  listingErrorSubtitle,
  listingErrorCode,
  recommendedMessage,
  recommendedList,
  noTrainFound,
}: railsListingShowErrorScreenInterface) => {
  return {
    type: ACTION_RAILS_LISTING_ERROR,
    data: {
      errorCode: listingErrorCode,
      errorMessage: listingErrorMessage,
      errorSubtitle: listingErrorSubtitle,
      errorFlag: true,
      recommendedMessage: '',
      recommendedList: [],
      noTrainFound,
      trainsList: [],
      minPriceDetails: {},
      minDuration: null,
    },
  };
};

export const connectedTravelApiResponse = async (payload) => {
  const {
    originStation,
    destinationStation,
    departureDate,
    maxLimitSuggestionsPerOption,
    suggestionSource,
    connectedTravelVersion,
  } = payload;
  const body = {
    sourceStationCode: originStation,
    destinationStationCode: destinationStation,
    dateOfJourney: departureDate,
    ...maxLimitSuggestionsPerOption && { maxLimitSuggestionsPerOption },
    ...suggestionSource && { suggestionSource },
    ...connectedTravelVersion && { connectedTravelVersion },
  };
  const res = await fetch2(railsConfig.connectedTraveller, {
    method: 'POST',
    body: JSON.stringify(body)
  });
  const connectedTravelApiResponse = await res.json();
  if (connectedTravelApiResponse?.error || res?.status !== 200) {
    return null;
  }
  return connectedTravelApiResponse;
}

export const getNewTrainsList = (from, to, date) => async (dispatch, getState) => {
  // trackNewListingLoad(from, to);
  const loadFromMigratedURL = getCanLoadListingv3();
  if (loadFromMigratedURL){
    dispatch(getMigratedTrainsList(from, to, date));
    return;
  }

  dispatch({
    type: ACTION_RAIL_LISTING_REMOVE_WEBVIEW,
    data: {
      showWebview: false,
    }
  });
  const {
    railsListing: { originStation, destinationStation, departureDate },
    railsVernacular: { texts },
    railsLanding: { selectedClass },
  } = getState();
  let showNoTrainView = false;
  let listingErrorCode = '';
  let listingErrorMessage = '';
  let listingErrorSubtitle = '';
  let recommendedDate = undefined;
  let recommendedList = [];
  let recommendedMessage = '';
  let noTrainFound = false;
  let otherDayTrainsList =null;

  try {
    const overAllStart = performance.now();
    const { code: fromCode, stationName: fromStation } = from;
    const { code: toCode, stationName: toStation } = to;
    const deptDate = fecha.format(date, 'YYYYMMDD');
    const searchUrl = `${railsConfig.searchUrlNewListing}/${fromCode}/${toCode}/${deptDate}?selectedClass=${selectedClass}`;
    const urlWithParams = `${searchUrl}&source=${encodeURI(fromStation)}&destination=${encodeURI(toStation)}`;
    dispatch({
      type: ACTION_INIT_RAIL_LISTING,
    });
    const header = await getRailsPostHeaders();
    const apiStart = performance.now();
    const res = await fetch2(urlWithParams, {
      headers: header,
      signal: Timeout(API_TIMEOUT).signal,
    });
    const responseJson = await res.json();
    if (responseJson?.responseFrom === RESPONSE_FROM_CACHE) {
      trackNewListingEvent(RAILS_DOWNTIME_CACHE);
    }
    responseJson.otherDayTrainsList = []; // Block ODT
    const tbsApiTime = (performance.now() - apiStart);
    logGrafanaLatencyMetrics(
      PAGE.LISTING_V2,
      ENTITY_TYPE.API,
      ENTITY.SEARCH_API,
      COMMON_LATENCY.TOTAL,
      tbsApiTime,
    );
    dispatch({
      type: ACTION_INIT_BREAK_JOURNEY,
      data: {
        breakJourneyList: []
      }
    });
    if (responseJson?.showBreakJourney) {
      dispatch(getBreakJourneyList(from, to, date));
    }
    if (isEmpty(responseJson)) {
      trackListingError(RAILS_LISTING,'TRAINS:Listing_response_json_is_null');
      throw new Error('response json is null');
    }

    if (!isEmpty(responseJson?.errorMessage)) {
      trackListingError(RAILS_LISTING,`TRAINS:Listing_${responseJson.errorMessage}`);
      logGrafanaErrorMetrics(
        PAGE.LISTING_V2,
        ENTITY_TYPE.API,
        ENTITY.SEARCH_API,
        responseJson?.errorMessage,
        res.status,
      );
    }
    dispatch(toggleNearbyDatesList(false, '', '', ''));
    dispatch({
      type: ACTION_INT_NEARBY_DATES_LIST,
      data: {}
    })

    if (responseJson.safetyGuideLines) {
      dispatch({
        type: COVID_SAFETY_CARD_LISTING,
        data: {
          covidSafetyCardData: responseJson.safetyGuideLines
        }
      });
    }
    if (!responseJson.safetyGuideLines) {
      dispatch({
        type: COVID_SAFETY_CARD_LISTING,
        data: {
          covidSafetyCardData: {}
        }
      });
    }
    if (responseJson.displayCovidForm && responseJson.covidFormLink) {
      dispatch({
        type: ACTION_RAIL_LISTING_SHOW_WEBVIEW,
        data: {
          showWebview: true,
          webviewUrl: responseJson.covidFormLink,
          webviewHeader: responseJson.covidFormHeader || '',
          goBackUrl: responseJson.goBackUrl || '',
          from,
          to,
          deptDate,
        }
      });
      return;
    } else if (isEmpty(responseJson.trainBtwnStnsList)) {
      showNoTrainView = true;
      recommendedDate = responseJson?.recommendedDate;
      // eslint-disable-next-line prefer-destructuring
      noTrainFound = responseJson?.noTrainFound;
      recommendedMessage = recommendedDate?.recommendedMessage || '';
      recommendedList = recommendedDate?.recommendedList || [];
      listingErrorCode = responseJson?.errorDetails?.errorCode;
      listingErrorMessage =
        responseJson?.error ||
        responseJson?.errorMessage ||
        _label('no_trains_found_on_this_route');
      listingErrorSubtitle = _label('try_searching_nearby_cities');
    } else {
      const trainsList = dispatch(buildTrainList(responseJson.trainBtwnStnsList));
      const { quotaList, showAlternateAvailability } = responseJson;
      const trainsListObject = trainsList.reduce((acc, item) => {
        const { avlClasses } = item;
        const selectedQuota = QuotaType.GN;
        const quotaClassRate = getQuotaClassRate(quotaList, avlClasses);
        return {
          ...acc,
          [item.trainNumber]: {
            selectedQuota,
            quotaClassRate,
            selectedClassType: avlClasses[0],
            selectedDate: null,
            error: false,
            errorMessage: '',
            availabilityResponse: null,
            isLoading: false
          }
        };
      }, {});
      const availableQuotaList = getOrderedQuotaList(quotaList);
      const clientConfig = isEmpty(responseJson.clientConfig) ?
        null : responseJson.clientConfig;
      const minPriceDetails = responseJson?.minPriceDetails;
      const minDuration = responseJson?.minDuration;
      const filterObject = getFilterObject(trainsList, from, to, texts,getState);
      removeTtuTrackingEvars();
      const availabilityTracking =
        (responseJson?.availabilityBucket
          ? `${availabilityBucketOmnitureMapping?.[responseJson?.availabilityBucket]}|`
          : '') + calculateTtuExtent(trainsList);
      updateEvar47or97Variable(availabilityTracking);

      dispatch({
        type: ACTION_INIT_RAILS_LISTING_FILTERS,
        data: { filterObject }
      });
      dispatch({
        type: ACTION_RAILS_LISTING_COMPLETE,
        data: {
          searchData: trainsList,
          availableQuotaList,
          trainsListObject,
          selectedTrainInfo: null,
          showClassAvailability: false,
          clientConfig,
          showAlternateAvailability: !!showAlternateAvailability,
          minPriceDetails,
          minDuration,
          showBnpp: responseJson.showBnpp,
          omnitureDetails: responseJson?.omnitureDetails,
        },
      });
      let tbsRenderTime = performance.now() - overAllStart;
      tbsRenderTime = tbsRenderTime - tbsApiTime;
      logGrafanaLatencyMetrics(
        PAGE.LISTING_V2,
        ENTITY_TYPE.PAGE,
        COMMON_LATENCY.FIRST_RENDER,
        PAGE.LISTING_V2,
        tbsRenderTime,
      );
      const connectedTravelPokusVal = getIfToShowRailsConnectedTravel();
      if (connectedTravelPokusVal) {
        if (responseJson?.callForCt) {
          dispatch(setConnectedTravelData(fromCode, toCode, date));
        } else {
          removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown);
          removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedShown);
        }
      } else {
        trackConnectedEvar47or97Event(
          LISTING_PAGE_TRACKING_KEY,
          LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown,
        );
      }
      firebaseListingTracker({ originStation, destinationStation, departureDate });
      await dispatch(
        fetchConfirmationChancesForTrains(
          trainsList,
          deptDate,
          QuotaType.GN,
          from,
          to,
          date,
          overAllStart,
          tbsApiTime,
        ),
      );
      const { railsLanding, railsListing } = getState();
      const locusDetails = railsLanding?.LocusDetails;
      if (isLocusEmpty(locusDetails)) {
        try {
          const locusDetail = await getLocusIdFromStationDetails({
            from_station_code: originStation?.code,
            to_station_code: destinationStation?.code,
          });
          dispatch(setLocusData(locusDetail));
        } catch (error) {
          //Ignore error
        }
      }
      trackPdtListingLoad(
        getListingPagePdt(undefined, railsLanding, railsListing, null),
        RAIL_SEARCH_CONTEXT_DATA_TYPE,
        null,
      );
      trackPdtListingLoad(
        getListingPagePdt(trainsList, railsLanding, railsListing, null),
        RAIL_LISTING_PAGE_DATA_TYPE,
        null,
      );
      // dispatch(tuneRailsListingLoad(from, to, date));
    }
  } catch (error) {
    trackListingError(RAILS_LISTING,'TRAINS:Listing_something_went_wrong');
    showNoTrainView = true;
    let errorCodeLatest = error?.errorCode || listingErrorCode;
    listingErrorMessage = _label('something_went_wrong');
    listingErrorSubtitle = `${_label('please_try_again_after_some_time')} Error Code: ${errorCodeLatest}`;
    const { code: fromCode, stationName: fromStation } = from || {};
    const { code: toCode, stationName: toStation } = to || {};
    const errorData = {
      catchedErrorMesage: error?.message,
      railsFromCode: fromCode,
      railsFromStation: fromStation,
      railsToCode: toCode,
      railsToStation: toStation,
      railsRawDeptDate: date,
    };
    logErrorToFirebase(errorData);
    logGrafanaErrorMetrics(
      PAGE.LISTING_V2,
      ENTITY_TYPE.API,
      ENTITY.SEARCH_API,
      error?.message,
      3100,
    );
  }
  if (showNoTrainView) {
    dispatch({
      type: ACTION_RAILS_LISTING_ERROR,
      data: {
        errorCode: listingErrorCode,
        errorMessage: listingErrorMessage,
        errorSubtitle: listingErrorSubtitle,
        errorFlag: true,
        recommendedMessage,
        recommendedList,
        noTrainFound,
        trainsList: [],
        minPriceDetails: {},
        minDuration: null
      },
    });

    try {
      dispatch(connectedTravellerforDeadEnds(from, to, date, listingErrorCode));
    } catch (error) {
      console.error('error in fetching connected travellers for dead end', error);
    }
  }
};

export const getRailsPostHeaders = async () => {
  const header = await botmanSensorHeader();
  return  {
  ...header,
  'mmt-sorting-logic': getRailsListingSortingLogic()?.toString(),
  };
};
export const getBreakJourneyList = (from, to, date) => async (dispatch) => {
  const fromCode = from.code;
  const toCode = to.code;
  const deptDate = fecha.format(date, 'YYYY-MM-DD');

  const breakJourneyRequest = {
    fromStationCode: fromCode,
    toStationCode: toCode,
    dateOfJourney: deptDate
  };

  try {
    const breakJourneyResponse = await getBreakJourneyRoutesApi(breakJourneyRequest);
    if (breakJourneyResponse && breakJourneyResponse.breakJourneyList) {
      dispatch({
        type: ACTION_INIT_BREAK_JOURNEY,
        data: { breakJourneyList: breakJourneyResponse.breakJourneyList }
      });
    } else {
      dispatch({
        type: ACTION_INIT_BREAK_JOURNEY,
        data: { breakJourneyList: [] }
      });
    }
  } catch (error) {
    console.log(error)
    dispatch({
      type: ACTION_INIT_BREAK_JOURNEY,
      data: { breakJourneyList: [] }
    });
  }
};

export const clearBreakJourneyList = () => (dispatch: any) => {
  dispatch({
    type: ACTION_INIT_BREAK_JOURNEY,
    data: {
      breakJourneyList: []
    }
  });
}

export const connectedTravellerforDeadEnds = (
  from: any,
  to: any,
  date: Date,
  listingErrorCode: string,
) => (dispatch: any) => {
  const connectedTravelPokusVal = getIfToShowRailsConnectedTravel();
  if (connectedTravelPokusVal) {
    const { code: fromCode } = from || {};
    const { code: toCode } = to || {};
    if (listingErrorCode === 'RAIL_TBS_03_CODE') {
      dispatch(setConnectedTravelData(fromCode, toCode, date, true));
    } else {
      removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown);
      removeEventFromEvar47or97Variable(LISTING_CONNECTED_TRAVEL_EVENTS.connectedShown);
      dispatch({
        type: ACTION_SET_CONNECTED_TRAVEL_LIST,
        data: {
          connectedTravelApiResponseJson: null,
        },
      });
    }
  } else {
    dispatch({
      type: ACTION_SET_CONNECTED_TRAVEL_LIST,
      data: {
        connectedTravelApiResponseJson: null,
      },
    });
    trackConnectedEvar47or97Event(
      LISTING_PAGE_TRACKING_KEY,
      LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown,
      );
  }
  };

export const onViewDetailsClicked = (trainData) => async (dispatch, getState) => {
  const { trainNumber } = trainData;
  const {
    railsListing: { trainsListObject },
  } = getState();
  const requiredTrainObject = trainsListObject[trainNumber];
  const { availabilityResponse } = requiredTrainObject;
  if (isEmpty(availabilityResponse)) {
    const { selectedClassType, selectedQuota } = requiredTrainObject;
    dispatch(updateAvailabilityList(trainData, selectedClassType, selectedQuota?.code));
  } else if (!isEmpty(availabilityResponse) && (availabilityResponse.errorMessage || availabilityResponse.error)) {
    const { selectedClassType, selectedQuota } = requiredTrainObject;
    dispatch(updateAvailabilityList(trainData, selectedClassType, selectedQuota?.code));
  }
};

export const initAvailabilityStateOfTrain = (trainNumber,isOtherDayTrainsList=false) => (dispatch, getState) => {
  const {
    railsListing: { trainsListObject,otherDayTrainsListObject },
  } = getState();

  if (!isOtherDayTrainsList) {
    const updatedTrainsListObject = {
      ...trainsListObject,
      [trainNumber]: {
        ...trainsListObject[trainNumber],
        isLoading: true,
        error: false,
        errorMessage: ''
      }
    };
    dispatch({
      type: ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN,
      data: updatedTrainsListObject
    });
  }
  else {
    const updatedTrains = {
      ...otherDayTrainsListObject,
      [trainNumber]: {
        ...otherDayTrainsListObject[trainNumber],
        isLoading: true,
        error: false,
        errorMessage: ''
      }
    };
    dispatch({
      type: ACTION_INIT_AVAILABILITY_STATE_OF_TRAIN_FOR_ODT,
      data: updatedTrains
    });
  }
};

const getAvailabilityList = (response) => {
  return get(response, "originalData.avlDayList", response.avlDayList);
}

const confirmProbablityForNearbyDates = (
  response: { trainName: string; avlDayList: any; },
  trainNumber: string,
  quotaSelected: string,
  quotaClassRate: any,
  selectedClassType: string,
  trainData: { frmStnCode: string; toStnCode: string; },
  updatedTrainsListObject: any,
  selectedBookingDate: any,
  isOtherDayTrainsList=false
) => async (dispatch: any, getState: any) => {
  try {
    const {
      confirmationGuaranteeConfig: { railsConfirmationGuaranteeOption = 0 } = {},
      freeCancellationConfig: { freeCancellationEnabled = false } = {},
    } = getState().railsListing;

    const request = {
      trainNumber,
      quota: quotaSelected,
      ticketClass: selectedClassType,
      boardingStationCode: trainData.frmStnCode,
      destinationStationCode: trainData.toStnCode,
      trainAvailabilityDayBasisList: getAvailabilityList(response),
      railsConfirmationGuaranteeOption,
      zcEnable: freeCancellationEnabled,
    };
    const url = railsConfig.neabyDatesProbablityUrl;
    const res = await fetch2(url, {
      method: 'POST',
      headers: getDefaultPostHeaders(),
      body: JSON.stringify(request)
    });
    const responseJson = await res?.json();
    // ===========================================================================================
    //      Error handling here is in confusing manner and also error scenarios are not clear
    //      as of now hence notmaking any drastic change. BUT
    //      once the error scenarios are clear, error handling should be done in
    //      proper manner with try-catch block.
    // ============================================================================================
    if (!isEmpty(responseJson)) {
      const newTrainsListObject = {
        ...updatedTrainsListObject,
        [trainNumber]: {
          ...updatedTrainsListObject[trainNumber],
          availabilityResponse: {
            ...response,
            ...responseJson,
            avlDayList: responseJson.trainAvailabilityDayBasisList
          },
          error: responseJson.error ?? false,
          errorMessage: responseJson.errorMessage ?? "",
          quotaClassRate,
          selectedBookingDate,
          isLoading: false
        }
      }
      if (isOtherDayTrainsList) {
        dispatch({
          type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN_FOR_ODT,
          data: newTrainsListObject
        });
      }
      else {
        dispatch({
          type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN,
          data: newTrainsListObject
        });
      }
    } else {
      if (isOtherDayTrainsList) {
        dispatch({
          type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN_FOR_ODT,
          data: updatedTrainsListObject
        });
      }
      else
      {
      dispatch({
        type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN,
        data: updatedTrainsListObject
      });
    }
    }
  } catch {
    console.log('error in fetching nearby dates confirmation propbablity');
    dispatch({
      type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN,
      data: updatedTrainsListObject
    });
  }
}

function convertToFetchaFormat(input) {
  // Extract year, month, and day from the input string
  const year = input.substring(0, 4);
  const month = input.substring(4, 6);
  const day = input.substring(6, 8);

  // Create a Date object with the extracted values
  const dateObject = new Date(`${year}/${month}/${day}`);

  // Check if the date is valid
  if (!isNaN(dateObject.getTime())) {
    return dateObject;
  } else {
    return "Invalid date";
  }
}
export const updateAvailabilityList = (trainData, selectedClassType, quotaSelected) =>
  async (dispatch, getState) => {
    try {
      const { trainNumber } = trainData;
      dispatch(initAvailabilityStateOfTrain(trainNumber));
      const { railsListing: { trainsListObject, departureDate } } = getState();


      const response = await
        getAvailabilityResponse(selectedClassType, trainData, quotaSelected, departureDate,null,null,true);
      if (!isEmpty(response.errorMessage)) {
          dispatch({
            type: ACTION_UPDATE_AVAILABILITY_OF_TRAIN,
            data: {
              ...trainsListObject,
              [trainNumber]: {
                ...trainsListObject[trainNumber],
                error: true,
                errorMessage: response.errorMessage,
                isLoading: false
              }
          },
          });
        return;
      }

      const { avlDayList, originalAvlDayList }  = getAvlDayList(response, trainData);
      const { quotaClassRate } = trainsListObject[trainNumber];
      const { travelplexChatConfig, travelplexTickers } = response?.travelplexConfig || {};
      const newQuotaClassRate = {
        ...quotaClassRate,
        [quotaSelected]: {
          ...quotaClassRate[quotaSelected],
          [selectedClassType]: { rate: response.totalFare }
        }
      };
      const selectedBookingDate = avlDayList[0];
      const updatedTrainsListObject = {
        ...trainsListObject,
        [trainNumber]: {
          ...trainsListObject[trainNumber],
          availabilityResponse: response,
          quotaClassRate: newQuotaClassRate,
          selectedBookingDate: originalAvlDayList[0],
          isLoading: false,
        },
      };
      if (quotaSelected === 'GN') {
        dispatch(setNewTbsAvailability(response, selectedClassType, quotaSelected, trainData));
      }
      dispatch(
        confirmProbablityForNearbyDates(
          response,
          trainNumber,
          quotaSelected,
          newQuotaClassRate,
          selectedClassType,
          trainData,
          updatedTrainsListObject,
          selectedBookingDate,
        ),
      );
      dispatch({
        type: ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
        data: {
          travelplexChatConfig,
          travelplexTickers,
        },
      });
    } catch (error) {
      console.error("JS ERROR in updateAvailabilityList", error.message);
    }

  };

export const getNewQuotaClickData = (classType, quotaCode, trainData) => {
  const { trainName, trainNumber } = trainData;
  return `${trainName}|${trainNumber}|${quotaCode}|${classType}|NA|NA`;
};

export const onNewQuotaClicked = (quotaSelected, trainData) => (dispatch, getState) => {
  const { railsListing: { trainsListObject } } = getState();
  const selectedQuota: QuotaTypeInterface = getQuota(quotaSelected);
  const { trainNumber } = trainData;
  const { selectedClassType } = trainsListObject[trainNumber];
  trackNewListingEvent(
    `mob_rail_listing_v2_quota_${selectedQuota?.code}_applied`,
    getNewQuotaClickData(selectedClassType, selectedQuota?.code, trainData)
  );
  const updatedTrainsListObject = {
    ...trainsListObject,
    [trainNumber]: {
      ...trainsListObject[trainNumber],
      selectedQuota
    }
  };
  dispatch({
    type: ACTION_UPDATE_QUOTA_SELECTED_OF_TRAIN,
    data: updatedTrainsListObject
  });
    dispatch(updateAvailabilityList(trainData, selectedClassType, selectedQuota?.code));
};
export const getNewClassTypeClickData = (classType, quotaCode, trainData) => {
  const { trainName, trainNumber } = trainData;
  return `${trainName}|${trainNumber}|${quotaCode}|${classType}|NA|NA`;
};

export const onNewClassTypeClicked = (classTypeSelected, trainData) => (dispatch, getState) => {
  const {
    railsListing: { trainsListObject },
  } = getState();
  const { trainNumber } = trainData;
  const { selectedQuota } = trainsListObject[trainNumber];
  trackNewListingEvent(
    `mob_rail_listing_v2_class_${classTypeSelected}_selected`,
    getNewClassTypeClickData(classTypeSelected, selectedQuota?.code, trainData)
  );
  const updatedTrainsListObject = {
    ...trainsListObject,
    [trainNumber]: {
      ...trainsListObject[trainNumber],
      selectedClassType: classTypeSelected
    }
  };
  dispatch({
    type: ACTION_UPDATE_CLASS_TYPE_SELECTED_OF_TRAIN,
    data: updatedTrainsListObject
  });
  dispatch(updateAvailabilityList(trainData, classTypeSelected, selectedQuota?.code));
};

export const closeStationChangeAlert = () => ({
  type: ACTION_STATION_CHANGE_ALERT,
  data: {
    displayStationChangeAlert: false
  }
});

export const closeConfirmOptionsBottomSheet = () => ({
  type: ACTION_CONFIRM_OPTIONS_ALERT,
  data: {
    displayConfirmOptionsBottomSheet: false
  }
});

export const toggleTrainScheduleBottomSheet = ( showBottomSheet: boolean, trainNumber = '' ) => ({
  type: ACTION_TOGGLE_TRAIN_SCHEDULE_BOTTOM_SHEET,
  data: {
    displayTrainScheduleBottomSheet: showBottomSheet,
    trainNumberForSchedule: trainNumber,
  }
})

export const toggleConnectedTravelBottomSheet = ( showBottomSheet: boolean, proceedToTraveler: boolean ) => (dispatch) => {

  if(!showBottomSheet && !proceedToTraveler) {
    trackClickEventProp61(RAILS_LISTING, LISTING_CONNECTED_TRAVEL_EVENTS.bottomSheetDismissClick);
  }

  dispatch({
    type: ACTION_TOGGLE_CONNECTED_TRAVEL_BOTTOM_SHEET,
    data: {
      displayConnectedTravelBottomSheet: showBottomSheet,
    }
  });
}

export const dispatchConnectedBottomSheetData = (data: any) => (dispatch) => {
  dispatch({
    type: ACTION_CONNECTED_TRAVEL_BOTTOM_SHEET_DATA,
    data: {
      connectedBottomSheetData: data,
    }
  });
  return;
}

export const verifyTatkalExists = availableQuotaList => (
  availableQuotaList.some(item => (item === 'TQ'))
);

export const tuneRailsListingLoad = (originStation, destinationStation, departureDate) => () => {
  tuneRailsListingLoadTracker({
    from: originStation.cityName,
    to: destinationStation.cityName,
    date: fecha.format(departureDate, 'DD-MM-YYYY'),
    travelByAc: 'N'
  });
};

const initAbConfigForConfirmationChance = () => (dispatch, getState) => {
  const railsShowConfirmationChance = getPokusConfig(PokusLobs.RAIL, AbConfigKeyMappings.railsShowConfirmationChance, false);
  dispatch({
    type: ACTION_INIT_SHOW_CONFIRMATION_CHANCE_AB,
    data: {
      railsShowConfirmationChance: isUndefined(railsShowConfirmationChance) ? false : railsShowConfirmationChance
    }
  });
};

export const initOmniture = () => (dispatch) => {
  dispatch({
    type: ACTION_RAILS_LISTING_OMNITURE,
    data: {
      newListingLoadOmitureDone: false,
      confirmationProbabilityOmitureDone: false,
      noTrainsViewOmnitureDone: false,
      noDirectTrainsFoundOmnitureDone: false,
      tuneTrackerOmnitureDone: false,
    },
  });
}

let prevUrlListing;

export const initNewListing = (props) => (dispatch) => {
  if (Platform.OS === 'web') {
    if (prevUrlListing === window.location.href) {
      return;
    } else {
      prevUrlListing = window.location.href;
    }
  }
  dispatch(initOmniture());
  dispatch(initAbConfigForConfirmationChance());
  dispatch(clearBookBreakJourney());
  dispatch(clearBreakJourneyList());
};
export const changeDepartureDate = (date, noApiCall) => (dispatch, getState) => {
  const { railsListing: { originStation, destinationStation } } = getState();
  dispatch({
    type: ACTION_DATE_CHANGED,
    data: date
  });
  dispatch({
    type: ACTION_DATE_SELECTED,
    data: date
  });
  if (!noApiCall || Platform.OS === 'web') {
    dispatch(getNewTrainsList(originStation, destinationStation, date));
  }
  dispatch(clearBreakJourneyList());
};


export const closeClassAvailability = () => ({
  type: ACTION_CLOSE_CLASS_AVAILABILITY,
  data: {
    showClassAvailability: false,
    displayStationChangeAlert: false
  }
});

export const getDefaultPostHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json'
});

export const getAvlDayList = (response, selectedTrainInfo) => {
  return {
    avlDayList: response.avlDayList,
    originalAvlDayList: response.originalData?.avlDayList || response.avlDayList,
  }
}

export const getDefaultAvlStatus = (avlDayList, selectedDate) => {
  let avlStatus = null;
  avlDayList.forEach((item) => {
    if (item.availablityDate === selectedDate) {
      avlStatus = item.availablityStatus;
    }
  });
  return avlStatus;
};

export const isBookNowEnabled = selectedBookingDate => (
  !(isEmpty(selectedBookingDate) || isEmpty(selectedBookingDate.availablityStatus) ||
    selectedBookingDate.availablityStatus.startsWith(AvailabilityStatusTypes.NOTAVAILABLE.code) ||
    selectedBookingDate.availablityStatus === AvailabilityStatusTypes.DEPARTED.code ||
    selectedBookingDate.availablityStatus.startsWith(AvailabilityStatusTypes.REGRET.code) ||
    selectedBookingDate.availablityStatus.startsWith(AvailabilityStatusTypes.TRAIN_CANCELLED.code) ||
    selectedBookingDate.availablityStatus === AvailabilityStatusTypes.CLASS_NOT_EXIST.code)
);

export const setLandingData = landingData => ({
  type: ACTION_SET_PPBOOKING_LANDING_DATA,
  data: landingData
});

export const goToTravelersPage = (dispatch, getState) => {
  const { railsListing: { selectedTrainInfo, departureDate, selectedClassType, selectedQuota } } = getState();
  dispatch(trackEvents);
  dispatch(closeStationChangeAlert());
  dispatch(closeConfirmOptionsBottomSheet());
  Actions.travelers({
    originStation: {
      cityName: selectedTrainInfo.frmStnName,
      code: selectedTrainInfo.frmStnCode,
      stationName: selectedTrainInfo.frmStnName
    },
    destinationStation: {
      cityName: selectedTrainInfo.toStnName,
      code: selectedTrainInfo.toStnCode,
      stationName: selectedTrainInfo.toStnName
    },
    departureDate,
    trainNumber: selectedTrainInfo.trainNumber,
    classCode: selectedClassType,
    quota: selectedQuota?.code,
    inNormalFlow: true
  });
};

export const trackEvents = (dispatch, getState) => {
  const {
    railsListing: {
      selectedClassType: classValue,
      selectedQuota,
      selectedBookingDate,
      selectedTrainInfo,
      pageSource,
    },
  } = getState();
  const { trainName, trainNumber } = selectedTrainInfo;
  const { availablityStatus: selectedAvlStatus } = selectedBookingDate;
  // eslint-disable-next-line max-len
  const commonDataForTravelerTracking = `${trainName}|${trainNumber}|${selectedQuota?.code}|${classValue}|${selectedAvlStatus}|NA`;
  trackTravellerPageLoad(commonDataForTravelerTracking, pageSource);
};

const createConfirmationPredictionRequest = (trainsList, doj, quota, railsConfirmationGuaranteeOption: number, freeCancellationEnabled: boolean) => {
  const request = {
    departureDate: doj,
    trainBtwnStnsList: trainsList,
    railsConfirmationGuaranteeOption,
    zcEnable: freeCancellationEnabled,
  };

  return request;
};


export const getConfirmationChance = async (confirmationPredictionURL: string, confirmationPredictionRequest: any) => {
  try {
    const res = await fetch2(confirmationPredictionURL, {
      method: 'POST',
      headers: getDefaultPostHeaders(),
      body: JSON.stringify(confirmationPredictionRequest)
    });
    const responseJson = await res.json();
    if (!isEmpty(responseJson)) {
      return responseJson;
    }
    return confirmationPredictionRequest;
  } catch (err) {
    return confirmationPredictionRequest;
  }
};

interface QuotaFetchConfirmation {
  id: string; // convert to ENUM
  text: string; // convert to ENUM
  code: string; // convert to ENUM
  value: string; // convert to ENUM
}

export const saveConfirmationGuaranteeConfig = (railsConfirmationGuaranteeOption: number, hasWidgetError = false) => async (dispatch: any, getState: any) => {
  const { confirmationGuaranteeConfig = {} } = getState().railsListing;
  const confirmationGuaranteeConfigObj = {
    ...confirmationGuaranteeConfig,
    railsConfirmationGuaranteeOption
  };

  if (hasWidgetError) {
    confirmationGuaranteeConfigObj.confirmationGuaranteeWidget = null;
    confirmationGuaranteeConfigObj.isInit = false;
  }

  dispatch({
    type: SAVE_CONFIRMATION_GUARANTEE_POKUS_OPTION,
    data: {
      confirmationGuaranteeConfig: confirmationGuaranteeConfigObj
    },
  });
}

export const saveFreeCancellationConfig = (freeCancellationEnabled: boolean) => (dispatch: any, getState: any) => {
  const { freeCancellationConfig = {} } = getState().railsListing;
  dispatch({
    type: SAVE_FREE_CANCELLATION_CONFIG,
    data: {
      freeCancellationConfig: {
        ...freeCancellationConfig,
        freeCancellationEnabled,
      },
    },
  });
};

export const fetchConfirmationChancesForTrains = (
  trainsList: any[],
  doj: string,
  quota: QuotaFetchConfirmation,
  from: StationFC,
  to: StationFC,
  date: Date,
  overAllStart: number,
  tbsApiTime: number,
) => async (dispatch: any, getState: any) => {

  const { confirmationGuaranteeConfig = {}, trainsList } = getState().railsListing;

  const railsConfirmationGuaranteeOption = await fetchConfirmationGuaranteeOption();
  const freeCancellationEnabled = await fetchFreeCancellationOption();

  dispatch(saveConfirmationGuaranteeConfig(railsConfirmationGuaranteeOption));
  dispatch(saveFreeCancellationConfig(freeCancellationEnabled));
  /*
    saving it separately because if we save with ACTION_UPDATE_TBS_CONFIRM_PROBABLITY
    then it depends on success of api whther it wiollo be saved or now
   */
  if (!railsConfirmationGuaranteeOption) {
    const railsShowCNFProbabilityOnSRP = await getPokusConfig(PokusLobs.RAIL, AbConfigKeyMappings.railsShowCNFProbabilityOnSRP, false);
    if (!railsShowCNFProbabilityOnSRP) {
      dispatch(getConfirmOptions(from, to, date));
      dispatch(setAlternateAvailabilityAction(true, from, to, date));
    }
    return;
  }

  try {
    const confirmationPredictionURL = railsConfig.confirmationProbablity;
    const confirmationPredictionRequest = createConfirmationPredictionRequest(trainsList, doj, quota, railsConfirmationGuaranteeOption, freeCancellationEnabled);
    const apiStart = performance.now();
    const trainsConfirmationChance: ConfirmationProbabilityResponse = await getConfirmationChance(confirmationPredictionURL, confirmationPredictionRequest);
    const confirmationApiTime = (performance.now() - apiStart);
    // trackTotalCardsOnListing(trainsConfirmationChance.trainBtwnStnsList, trainsList);
    if (!isEmpty(trainsConfirmationChance) && !isEmpty(trainsConfirmationChance.trainBtwnStnsList)) {
      const { filterObject = {} } = getState().railsListing;
      const { confirmationGuaranteeWidget } = trainsConfirmationChance;
      let noOfConfirmationGuaranteeTrains = 0;
      let noOfFreeCancellationTrains = 0;
      trainsConfirmationChance.trainBtwnStnsList.forEach(({ tbsAvailability }) => {
        tbsAvailability.forEach(({ confirmationGuaranteeText,freeCancellationText }) => {
          if (confirmationGuaranteeText) {
            noOfConfirmationGuaranteeTrains+=1
          }
          else if(freeCancellationText){
            noOfFreeCancellationTrains+=1
          }
        });
      });
      const ticketTypeFilter = createTicketTypeFilterObj(noOfConfirmationGuaranteeTrains,noOfFreeCancellationTrains);
      dispatch({
        type: ACTION_UPDATE_TBS_CONFIRM_PROBABLITY,
        data: {
          trainBtwnStnsList: trainsConfirmationChance.trainBtwnStnsList,
          trainsList,
          filterObject: {
            ...filterObject,
            ticketTypeFilter,
          },
          confirmationGuaranteeConfig: {
            ...confirmationGuaranteeConfig,
            isInit: false,
            confirmationGuaranteeWidget,
            railsConfirmationGuaranteeOption,
          },
        },
      });
    } else {
      dispatch(saveConfirmationGuaranteeConfig(railsConfirmationGuaranteeOption, true));
    }
    dispatch(getConfirmOptions(from, to, date));
    const totalAllTime = (performance.now() - overAllStart);
    const totalAPITime = tbsApiTime + confirmationApiTime;
    logGrafanaLatencyMetrics(
      PAGE.LISTING_V2,
      ENTITY_TYPE.PAGE,
      COMMON_LATENCY.OVERALL_RENDER,
      PAGE.LISTING_V2,
      totalAllTime,
    );
    logGrafanaLatencyMetrics(
      PAGE.LISTING_V2,
      ENTITY_TYPE.API,
      'listing_all_api',
      COMMON_LATENCY.TOTAL,
      totalAPITime,
    );

    dispatch(setAlternateAvailabilityAction(true, from, to, date));
  } catch (e) {
    dispatch(getConfirmOptions(from, to, date));
    dispatch(setAlternateAvailabilityAction(true, from, to, date));
    dispatch(saveConfirmationGuaranteeConfig(railsConfirmationGuaranteeOption, true));
  }
};

export const showBreakJourneyModal = msg => (dispatch) => {
  dispatch({
    type: ACTION_CHANGE_BJ_MODAL,
    data: { showBJUnavailable: { message: msg } }
  });
};

export const hideBreakJourneyModal = () => (dispatch) => {
  dispatch({
    type: ACTION_CHANGE_BJ_MODAL,
    data: { showBJUnavailable: null }
  });
};

export const initBookBreakJourney = (bookBreakJourney) => async (dispatch) => {
  dispatch({
    type: ACTION_BOOK_BJ_LOADING,
    data: {}
  });
  Actions.bookBreakJourney();
  try {
    const payload = {
      segmentList: bookBreakJourney?.segmentList?.map((segment) => {
        const { departureTime } = segment;
        const dTJs = getISTDateFromIsoDate(departureTime);
        const formattedMonth = getMonthMM(dTJs);
        const formattedDate = getDateDD(dTJs);
        const departureDate = `${dTJs.getFullYear()}-${formattedMonth}-${formattedDate}`;
        return {
          ...segment,
          departureDate
        }
      })
    };
    const breakJourneyResponse = await getBreakJourneyFareAndAvailApi(payload);
    if (isEmpty(breakJourneyResponse)) {
      throw { message: _label("something_went_wrong") };
    } else if (breakJourneyResponse.errorDetails) {
      throw breakJourneyResponse.errorDetails;
    } else {
      dispatch({
        type: ACTION_BOOK_BJ_COMPLETE,
        data: {
          selectedBreakJourney: { ...bookBreakJourney, ...breakJourneyResponse }
        }
      });
      dispatch({
        type: ACTION_BOOK_BJ_REMOVE_LOADER,
        data: {}
      });
    }
  } catch (e) {
    // @ts-ignore (REASON: Actions.currentScene is string but TS failed to infer the type)
    if (Actions.currentScene === 'bookBreakJourney') {
      Actions.pop();
    }
    dispatch({
      type: ACTION_BOOK_BJ_REMOVE_LOADER,
      data: {}
    });
    if (e.errorCode && e.errorCode === 'ERROR_BR_1') {
      const popUpMsg = e.errorMessage || 'This booking is no longer available as one of the train’s availability is over. Please try another option.';
      dispatch(showBreakJourneyModal(popUpMsg));
    } else {
      const errMsg = e.errorMessage || _label("something_went_wrong");
      showShortToast(errMsg);
    }
  }
};

export const clearSelectedBJTrainInfo = () => async (dispatch) => {
  dispatch({
    type: ACTIONS_SET_BJ_TRAIN_INFO,
    data: {
      selectedBJTrainInfo: null
    }
  });
}

export const clearBookBreakJourney = () => (dispatch) => {
  dispatch({
    type: ACTION_BOOK_BJ_COMPLETE,
    data: {
      selectedBJTrainInfo: null,
      selectedBreakJourney: null
    }
  });
}

export const bookBreakJourneyClicked = (data, breakJourneyId, hideLoader, travelers = [], isSecondLeg = false) => async (dispatch) => {
  try {
    const selectedTrainInfo = data.trainInfo;
    const { departureDateAndTime } = selectedTrainInfo;
    const { journeyClass, journeyQuota } = data;
    const response = await getAvailabilityResponse(journeyClass, selectedTrainInfo, journeyQuota, departureDateAndTime,null,null,true);
    if (!isEmpty(response.errorMessage)) {
      trackClickEventProp61(RAILS_LISTING,`rail_card_${response.errorMessage}`)
      showShortToast(response.errorMessage);
      return;
    }
    const { avlDayList, originalAvlDayList } = getAvlDayList(response, selectedTrainInfo);
    const formattedDate = fecha.format(departureDateAndTime, 'DD-MM-YYYY');
    const selectedAvlStatus = getDefaultAvlStatus(avlDayList, formattedDate);
    const selectedBookingDate = avlDayList[0];
    const { insuranceCharge, totalCollectibleAmount, totalFare, baseFare, applicableFoodTypes } = response;
    const selectedQuota: QuotaTypeInterface = getQuota(journeyQuota);

    const originStation = await getStationDetails({ code: selectedTrainInfo.frmStnCode });
    const destinationStation = await getStationDetails({ code: selectedTrainInfo.toStnCode });
    let breakJourneyDisclaimer = null;

    if (isSecondLeg === false) {
      const disclaimerResponse = await getDisclamerApi();
      if (!isEmpty(disclaimerResponse) && !disclaimerResponse.errorDetails) {
        breakJourneyDisclaimer = disclaimerResponse;
      }
    }

    const selectedBJTrainInfo = {
      isSecondLeg,
      breakJourneyId: breakJourneyId,
      breakJourneySegmentIndex: data.segmentIndex,
      originStation,
      destinationStation,
      selectedBookingDate: originalAvlDayList[0],
      breakJourneyDisclaimer
    }

    if (isSecondLeg) {
      selectedBJTrainInfo.travelers = travelers;
    }

    const dispatchData = {
      applicableFoodTypes,
      selectedClassType: journeyClass,
      selectedQuota,
      selectedBookingDate,
      originalSelectedBookingDate: originalAvlDayList[0],
      selectedAvlStatus,
      ...response.bkgCfg,
      travelAdvisoryDetails: response.travelAdvisoryDetails,
      insuranceCharge,
      totalCollectibleAmount,
      totalFare,
      baseFare,
      selectedTrainInfo,
      selectedBJTrainInfo,
      departureDate: departureDateAndTime,
      isBreakJourneySecondLeg: isSecondLeg
    };
    await dispatch({
      type: ACTION_BJ_SET_DATA_FOR_TRAVELERS_PAGE,
      data: dispatchData
    });
    trackClickEventProp61(RAILS_LISTING,`rail_card_${selectedAvlStatus}`)
    await dispatch(goToTravelersPage);
  } catch (e) {
    trackClickEventProp61(RAILS_LISTING,`rail_card_something_went_wrong`)
    console.log('Error occured while booking break journey', e);
    showShortToast(_label("something_went_wrong"+" Error Code: " + e?.errorCode ));
    return;
  }
  finally {
    if (hideLoader) {
      hideLoader();
    }
  }

}

export const breakJourneyRedirect = (breakJourneyId: string, stopLoader) => async (dispatch) => {
  try {
    const pendingLegDetails = await getPendingLegDetailsApi({ breakJourneyId });
    if (isEmpty(pendingLegDetails)) {
      throw { message: _label("something_went_wrong") };
    }
    else if (pendingLegDetails.errorDetails) {
      throw pendingLegDetails.errorDetails;
    }
    const travelerList = pendingLegDetails.travellerDetails;
    const trainInfo = pendingLegDetails.trainJourneyDetails;
    trainInfo.segmentIndex = pendingLegDetails.segmentIndex;
    await dispatch(bookBreakJourneyClicked(convertBJTrainInfoToNormalTrainInfo(trainInfo), pendingLegDetails.breakJourneyId, null, travelerList, true));
  }
  catch (e) {
    const errorToast = e.errorMessage || _label("something_went_wrong");
    showShortToast(errorToast);
  }
  finally {
    stopLoader();
  }
}

interface RailofyZcShown {
  railofyShown: boolean;
  zcShown: boolean
}

export const saveRailofyZcShown = (data: RailofyZcShown) => (dispatch: any, getState) => {
  const canShowBNPP = getIfCanShowBNPP();
  const { railofyShown, zcShown } = data;
  const showFCTGTogether = getIfToShowFCTGTogether();
  dispatch({
    type: SAVE_RAILOFY_ZC_SHOWN,
    data: {
      railofyZcShown: {
        railofyShown,
        zcShown: showFCTGTogether ? true : zcShown,
        bnppShown: canShowBNPP,
      },
    },
  });
};


/**
 *
 * Pdt related actions
 *
 */

export const getListingPagePdt = (searchData: any,railsLanding : any, railsListing : any,selectedClass : any ) => {
  const {originStation, destinationStation, departureDate} = railsListing;
  const searchContextData = getCommonSearchContextData(railsLanding);
  const data = {
    searchContext: {
      frmStnName: originStation?.cityName,
      frmStnCode: originStation?.code,
      toStnName: destinationStation?.cityName,
      toStnCode: destinationStation?.code,
      journeyDate: departureDate
    },
    ...searchContextData
  };
  if(isEmpty(searchData)) searchData = data;
  return {
    searchContextData : data,
    searchData,
    selectedClass,
    };
}
export const trackPdtListingLoad = async (
  data: any,
  dataType: string,
  listingErrorCodeString: string | null,
) => {
  const commonPdt = await getCommonPdtData();
  const pdtData = {
    ...commonPdt,
    ...data,
    listingErrorCodeString,
  };
  RailsPdtListingHelper.trackPageLoad(pdtData, dataType);
};

export const setSortAndFilterVersion = (version: string) => ({
  type: ACTION_RAILS_SORT_FILTER_VERSION,
  payload: version,
});

export const logErrorToFirebase = async (jsonData) => {
  try {
    if (Platform.OS === 'android' && getRailsPokusConfig(RailsAbConfig.railsReportCustomFirebaseErrors, false)){
      const internetInfo = await getCurrentInternetConnectionAndApproxSpeed();
      jsonData.internetInfo = internetInfo ?? 'NA';
      RailsModule?.logRailsListingError && RailsModule?.logRailsListingError(JSON.stringify(jsonData));
    }
  } catch (error){
    //ignore
  }
};

export const setConnectedTravelData = (
  fromCode: string,
  toCode: string,
  date: Date,
  showNoTrain = false,
) => async (dispatch: any) => {
  try {
    const deptDateConnectedTravellers = fecha.format(date, DATE_MONTH_YEAR_FORMAT);
    const ctV2ConfigResponse = await getConfigStore(configKeys.RAILS_CT_V2) || {};
    const showConnectedTravelV2 = getIfToShowConnectedTravelV2();
    const connectedTravelApiBody = {
      originStation: fromCode,
      destinationStation: toCode,
      departureDate: deptDateConnectedTravellers,
      suggestionSource:
        RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS?.[getRailsCtSource()]?.backendKey ||
        RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS[3].backendKey,
      maxLimitSuggestionsPerOption: ctV2ConfigResponse?.maxLimitSuggestionsPerOption || 3,
      connectedTravelVersion: 'V2',
    };
    if (showNoTrain) {
      dispatch({
        type: ACTION_SET_CONNECTED_TRAVEL_LIST,
        data: {
          showLoaderForRailsConnectedTravel: true,
        },
      });

    }

    let connectedTravelApiResponseJson = await connectedTravelApiResponse(connectedTravelApiBody);
    if (!isEmpty(connectedTravelApiResponseJson)) {
      updateEvar47or97Variable(RAILS_CONNECTED_TRAVEL_POKUS_CONSTANTS?.[getRailsCtSource()]?.omnitureKey);
        connectedTravelApiResponseJson = {
          ...connectedTravelApiResponseJson,
          date: fecha.format(date, DOUBLE_DIGIT_DATE_WITH_MONTH_FORMAT),
          twoTrains: connectedTravelApiResponseJson?.connectedTravelOptions?.filter((item) => {
            return item?.optionType === 'TWO_TRAINS';
          }),
          trainAndBus: connectedTravelApiResponseJson?.connectedTravelOptions?.filter((item) => {
            return item?.optionType === 'TRAIN_AND_BUS';
        }),
      };
      if (showConnectedTravelV2) {
        trackClickEventProp61(LISTING_PAGE_TRACKING_KEY, LISTING_CONNECTED_TRAVEL_EVENTS.ctv2);
      } else {
        trackClickEventProp61(LISTING_PAGE_TRACKING_KEY, LISTING_CONNECTED_TRAVEL_EVENTS.ctv1);
      }
      trackConnectedEvar47or97Event(
        LISTING_PAGE_TRACKING_KEY,
        LISTING_CONNECTED_TRAVEL_EVENTS.connectedShown,
      );
    } else {
      trackConnectedEvar47or97Event(
        LISTING_PAGE_TRACKING_KEY,
        LISTING_CONNECTED_TRAVEL_EVENTS.connectedNotShown,
      );
    }

    if (showNoTrain) {
      dispatch({
        type: ACTION_SET_CONNECTED_TRAVEL_LIST,
        data: {
          connectedTravelApiResponseJson,
          showLoaderForRailsConnectedTravel: false,
        },
      });

    }
    dispatch({
      type: ACTION_SET_CONNECTED_TRAVEL_LIST,
      data: {
        connectedTravelApiResponseJson,
      },
    });
  } catch (e) {
    if (showNoTrain) {
      dispatch({
        type: ACTION_SET_CONNECTED_TRAVEL_LIST,
        data: {
          showLoaderForRailsConnectedTravel: false,
        },
      });
    }
      console.error('Error in fetching connected Travel response: ', e);
  }
};

export const onAvailabilityDateClickedV2 =
  (
    selectedDate: FutureSelectedDateData,
    trainData: FutureSelectedTrain,
    selectedClassType: string,
    selectedQuota: string,
    isConfirmedOption: boolean = false,
  ) =>
  (dispatch: any, getState: any) => {
  const { trainNumber, avlClasses } = trainData;
  const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, selectedQuota);
  let updateTrainData = updateTimeInfoInSelectedTrain(trainData, selectedDate.availablityDate);
  const { railsListing: { nearbyDatesTrainsListObject } } = getState();
  const { availabilityResponse: response } = nearbyDatesTrainsListObject[selectedCardHash];
  const { avlDayList, originalAvlDayList } = getAvlDayList(response, trainData);
  const selectedAvlStatus = getDefaultAvlStatus(avlDayList, selectedDate.availablityDate);
  const selectedBookingDate = selectedDate;
  const quota: QuotaTypeInterface = getQuota(selectedQuota);

  if (!isBookNowEnabled(selectedBookingDate)) {
  showShortToast(_label("booking_not_available_for_this_train"));
  return;
  }
  const { insuranceCharge, totalCollectibleAmount, totalFare, baseFare, applicableFoodTypes } = response;
    const { stationChangeSign, clusterTrain, odt } = trainData;
    if (odt) {
      trackOdtEvar47or97Event(LISTING_PAGE_TRACKING_KEY,ODT_EVENTS.odt_chosen)
      trackClickEventProp61(LISTING_PAGE_TRACKING_KEY, ODT_EVENTS.odt_clicked);
    }
    if (isConfirmedOption) {
      const currentDayList = avlDayList.find(
        (avl) => avl.availabilityKey === selectedDate.availabilityKey,
      );
      const confirmedOption = currentDayList?.confirmedOption;
      updateTrainData = getTrainDataForNearbyDatesConfirmedOption(updateTrainData, confirmedOption);
    }

  const displayStationChangeAlert = getStationChangeAlertBottomsheetVal(clusterTrain, stationChangeSign);
  const dispatchData = {
    applicableFoodTypes,
    selectedTrainInfo: updateTrainData,
    selectedClassType,
    allAvailableClasses: avlClasses,
    selectedQuota: quota,
    selectedBookingDate,
    originalSelectedBookingDate: originalAvlDayList[0],
    selectedAvlStatus,
    avlDayList,
    ...response.bkgCfg,
    insuranceCharge,
    totalCollectibleAmount,
    displayStationChangeAlert,
    totalFare,
    baseFare
  };

  const railofyZcShown = {
    railofyShown: Boolean(selectedDate?.confirmationGuaranteeText),
    zcShown: Boolean(selectedDate.freeCancellationText),
  };

  dispatch(saveRailofyZcShown(railofyZcShown));
  dispatch({
    type: ACTION_SET_DATA_FOR_TRAVELERS_PAGE,
    data: dispatchData
  });
  if (!displayStationChangeAlert) {
    dispatch(goToTravelersPage);
  }
};


export const initNearbyDatesTrainList = (trainNumber, className, quotaSelected) => (dispatch, getState) => {
  const {
    railsListing: { nearbyDatesTrainsListObject },
  } = getState();

  const selectedCardHash = getSelectedCardHash(trainNumber, className, quotaSelected);

  const updatedTrainsListObject = {
    ...nearbyDatesTrainsListObject,
    [selectedCardHash]: {
      ...nearbyDatesTrainsListObject[selectedCardHash],
      isLoading: true,
      error: false,
      errorMessage: ''
    }
  };
  dispatch({
    type: ACTION_INT_NEARBY_DATES_LIST,
    data: updatedTrainsListObject
  });
};

export const toggleNearbyDatesList = ( showNearbyDates: boolean, selectedTrainNumber: string, selectedClassType: string, selectedQuota: string) => (dispatch, getState) => {
  const {
    railsListing: {
      nearbyDatesInfo: {
        selectedNearbyCardsHashList,
        selectedTrainsList
      }
    }
  } = getState();
  let updatedCardsHashList = selectedNearbyCardsHashList;
  let updatedTrainsList = selectedTrainsList;
  const selectedCardHash = getSelectedCardHash(selectedTrainNumber, selectedClassType, selectedQuota);

  if(showNearbyDates) {
    if(updatedTrainsList.includes(selectedTrainNumber)) {
      updatedCardsHashList = updatedCardsHashList.filter((item) => !item.includes(selectedTrainNumber));
    } else {
      updatedTrainsList.push(selectedTrainNumber);
    }
    updatedCardsHashList.push(selectedCardHash);
  } else {
    updatedCardsHashList = selectedTrainNumber ? updatedCardsHashList.filter((item: string) => !item.includes(selectedTrainNumber)) : [];
    updatedTrainsList = selectedTrainNumber ? updatedTrainsList.filter((item: string) => item != selectedTrainNumber) : [];
  }

  dispatch({
    type: ACTION_TOGGLE_NEARBY_DATES_LIST,
    data: {
      selectedNearbyCardsHashList: updatedCardsHashList,
      selectedTrainsList: updatedTrainsList
    }
  });
}

const getNearbyDatesAvlList = (availabilities, confirmedOptions) => {
  const avlList = [];

  for (const availabilityDate of Object.keys(availabilities ?? {})) {
    const currentAvailability = availabilities[availabilityDate]?.availabilityData;
    currentAvailability.availabilityKey = availabilityDate;
    if (!isEmpty(confirmedOptions) && confirmedOptions[availabilityDate]) {
      currentAvailability.confirmedOption = confirmedOptions[availabilityDate]?.availabilityData;
      currentAvailability.confirmedOption.availabilityKey = availabilityDate;
    }
    avlList.push(currentAvailability);
  }

  return avlList;
}

const getNearbyDatesAvlResponse = (avlDayList) => {
  const {
    travelAdvisoryDetails,
    insuranceCharge,
    totalCollectibleAmount,
    totalFare,
    baseFare,
    bkgCfg,
    applicableFoodTypes,
  } = avlDayList[0];

 const availabilityResponse = {
  travelAdvisoryDetails,
  insuranceCharge,
  totalCollectibleAmount,
  totalFare,
  baseFare,
  bkgCfg,
  applicableFoodTypes,
  avlDayList
 }

 return availabilityResponse
}

const getNearbyDatesConfirmedOptions =
  (trainData, selectedClassType: string, quotaSelected: string) => async (dispatch, getState) => {
    try{
      const {
        railsListing: {
          nearbyDatesTrainsListObject,
          departureDate
        }
      } = getState();
      const { trainNumber, possibleDates = [], odt } = trainData;

      const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, quotaSelected);
      const deptDate = odt ? possibleDates?.[0] : fecha.format(departureDate, 'YYYYMMDD');

      const urlWithParams = getNearbyDatesurl({
        fromCode: trainData.frmStnCode,
        toCode: trainData.toStnCode,
        deptDate,
        trainNumber,
        selectedClassType,
        quotaSelected,
        fromStation: trainData.frmStnName,
        toStation: trainData.toStnName,
        onlyConfirmedOptions: true,
      });

      const header = await getRailsPostHeaders();
      const res = await fetch2(urlWithParams, {
        headers: header,
      });
      const responseJson = await res.json();

      if(responseJson?.errorCode || isEmpty(responseJson?.confirmedOptions)) {
        console.error('Error in getting nearby dates confirmed options data:', responseJson?.errorMessage);
        return;
      }

      const currAvlDayList =
        nearbyDatesTrainsListObject[selectedCardHash]?.availabilityResponse?.avlDayList;

      const avlDayList = getNearbyDatesAvlList(currAvlDayList, responseJson?.confirmedOptions);
      const availabilityResponse = getNearbyDatesAvlResponse(avlDayList);
      const { travelplexChatConfig, travelplexTickers } = responseJson?.travelplexConfig || {};

      const updatedTrainsListObject = {
        ...nearbyDatesTrainsListObject,
        availabilityResponse,
      };

      dispatch({
        type: ACTION_UPDATE_NEARBY_DATES_LIST,
        data: updatedTrainsListObject,
      });

      dispatch({
        type: ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
        data: {
          travelplexChatConfig,
          travelplexTickers,
        },
      });
    } catch (e) {
      console.error('Error in getting nearby dates confirmed options data: ',e);
    }
}

export const updateNearbyDatesInfo = (trainData, selectedClassType: string, quotaSelected: string) =>
  async (dispatch, getState) => {

    const { trainNumber, possibleDates = [], odt } = trainData;
    const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, quotaSelected);
    dispatch(initNearbyDatesTrainList(trainNumber, selectedClassType, quotaSelected));
    const {
      railsListing: { nearbyDatesTrainsListObject, departureDate },
    } = getState();
    const currentTrainListObject = nearbyDatesTrainsListObject[selectedCardHash];
    try {

      const deptDate = odt ? possibleDates?.[0] : fecha.format(departureDate, 'YYYYMMDD');

      const urlWithParams = getNearbyDatesurl({
        fromCode: trainData.frmStnCode,
        toCode: trainData.toStnCode,
        deptDate,
        trainNumber,
        selectedClassType,
        quotaSelected,
        fromStation: trainData.frmStnName,
        toStation: trainData.toStnName,
        onlyConfirmedOptions: false,
      });

      const header = await getRailsPostHeaders();
      const res = await fetch2(urlWithParams, {
        headers: header,
      });
      const responseJson = await res.json();

      const { travelplexChatConfig, travelplexTickers } = responseJson?.travelplexConfig || {};

      let updatedTrainsListObject = {};

      if (res?.status !== 200 || responseJson?.errorCode) {
        updatedTrainsListObject = {
          ...nearbyDatesTrainsListObject,
          [selectedCardHash]: {
            ...currentTrainListObject,
            error: true,
            errorMessage: responseJson?.errorMessage || _label('something_went_wrong'),
            isLoading: false,
            showRetryIcon: responseJson?.canRetryError,
          }
        }
      } else {
        const avlDayList = getNearbyDatesAvlList(responseJson?.availabilities, responseJson?.confirmedOptions);
        const availabilityResponse =  getNearbyDatesAvlResponse(avlDayList);
        const responseFrom = responseJson?.availabilityResponseFrom;
        let trackingKey = '';
        if (responseFrom) {
          trackingKey = `nb_${responseFrom}`;
        }
        trackEventAfterRemovingOlderEvent(
          LISTING_PAGE_TRACKING_KEY,
          trackingKey,
          trackingKey
        );
        if (currentTrainListObject?.showRetryIcon) {
          trackEvar22Event(LISTING_PAGE_TRACKING_KEY, NEARBY_DATES_EVENTS.retrySuccess);
        }

        updatedTrainsListObject = {
          ...nearbyDatesTrainsListObject,
          [selectedCardHash]: {
            ...currentTrainListObject,
            availabilityResponse,
            selectedBookingDate: avlDayList[0],
            isLoading: false,
          }
        };
      }

      dispatch({
        type: ACTION_UPDATE_NEARBY_DATES_LIST,
        data: updatedTrainsListObject,
      });

      dispatch({
        type: ACTION_RAILS_TRAVELPLEX_CHAT_CONFIG,
        data: {
          travelplexChatConfig,
          travelplexTickers,
        },
      });

      if (responseJson?.shouldCallConfirmedOptionApi) {
        dispatch(getNearbyDatesConfirmedOptions(trainData, selectedClassType, quotaSelected));
      }
    } catch (error) {

      const updatedTrainsListObject = {
        ...nearbyDatesTrainsListObject,
        [selectedCardHash]: {
          ...currentTrainListObject,
          error: true,
          errorMessage: _label('inventory_availability_retry'),
          isLoading: false,
          showRetryIcon: true,
        },
      };

      dispatch({
        type: ACTION_NEARBY_DATES_ERROR,
        data: updatedTrainsListObject,
      });

      console.error('JS ERROR in updateNearbyDatesInfo: ', error);
    }
  };

export const nearbyDatesCardClick =
  (trainData, selectedClassType: string, selectedQuota: string) => async (dispatch, getState) => {
    const { trainNumber ,tbsAvailability} = trainData;
    const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, selectedQuota);
    const {
      railsListing: { nearbyDatesTrainsListObject },
    } = getState();
    const requiredTrainObject = nearbyDatesTrainsListObject[selectedCardHash];
    const availabilityResponse = requiredTrainObject?.availabilityResponse;
    const isResponeLoading = requiredTrainObject?.isLoading;

    if (requiredTrainObject?.showRetryIcon) {
      trackClickEventProp61(LISTING_PAGE_TRACKING_KEY, NEARBY_DATES_EVENTS.retryClick);
    }
    if ((isEmpty(availabilityResponse) || availabilityResponse?.error) && !isResponeLoading) {
      dispatch(updateNearbyDatesInfo(trainData, selectedClassType, selectedQuota));
    }
};

export const handleNearByDatesConfirmedOptionsClick =
  (
    selectedDate: FutureSelectedDateData,
    trainData: FutureSelectedTrain,
    selectedClassType: string,
    selectedQuota: string,
  ) =>
  (dispatch, getState) => {
    const { trainNumber, odt } = trainData;
    const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, selectedQuota);
    const {
      railsListing: {
        nearbyDatesTrainsListObject,
        trainsList,
        otherDayTrainsList,
        alternateAvailabilityResponse,
      },
    } = getState();
    const {
      availabilityResponse: { avlDayList },
    } = nearbyDatesTrainsListObject[selectedCardHash];

    const currentDayList = avlDayList.find(
      (avl) => avl.availabilityKey === selectedDate.availabilityKey,
    );
    const confirmedOption = currentDayList?.confirmedOption;

    const { confirmedOptionData, nearbyDatesAlternateAvlData } =
      getDataForConfirmedOptionsBottomSheet(
        confirmedOption,
        trainData,
        selectedClassType,
        selectedQuota,
      );
    let updatedTrainInfo = {};
    if (odt) {
      updatedTrainInfo = getDataForConfirmedOptions({
        availabilityItem: confirmedOptionData,
        trainData,
        trainsList: otherDayTrainsList,
      });
    } else {
      updatedTrainInfo = getDataForConfirmedOptions({
        availabilityItem: confirmedOptionData,
        trainData,
        trainsList,
      });
    }

    dispatch({
      type: ACTION_CONFIRM_OPTIONS_ALERT,
      data: {
        alternateAvailabilityResponse: {
          ...alternateAvailabilityResponse,
          nearbyDatesAlternateAvlList:[
            nearbyDatesAlternateAvlData
          ],
        },
        selectedClassType: `${selectedClassType}-${ALTERNATE_LISTING_IDENTIFIER}`,
        selectedQuota: getQuota(selectedQuota),
        selectedTrainInfo: updatedTrainInfo,
        isNearbyConfirmedOption: true,
      },
    });

    dispatch({
      type: ACTION_CONFIRM_OPTIONS_ALERT,
      data: {
        displayConfirmOptionsBottomSheet: true,
      },
    });
}

export const showSeatLockBottomSheet = () => ({
  type: ACTION_SEAT_LOCK_BOTTOMSHEET,
  data: { displaySeatLockBottomSheet: true },
});

export const closeSeatLockBottomSheet = () => ({
  type: ACTION_SEAT_LOCK_BOTTOMSHEET,
  data: { displaySeatLockBottomSheet: false },
});

export const handleNearbyDatesTtuCardClick =
  (
    selectedDate: FutureSelectedDateData,
    trainData: FutureSelectedTrain,
    selectedClassType: string,
    selectedQuota: string,
  ) =>
  async (dispatch, getState) => {
    const { trainNumber } = trainData;
    const selectedCardHash = getSelectedCardHash(trainNumber, selectedClassType, selectedQuota);
    const {
      railsListing: { nearbyDatesTrainsListObject },
    } = getState();
    let currentTrainListObject = nearbyDatesTrainsListObject[selectedCardHash];
    const {
      availabilityResponse: { avlDayList },
    } = currentTrainListObject;

    try {
      const departureDate = fecha.parse(selectedDate.availablityDate, 'DD-MM-YYYY');
      const responseJson = await getAvailabilityResponse(
        selectedClassType,
        trainData,
        selectedQuota,
        departureDate,
        null,
        null,
        false,
      );

      if (isEmpty(responseJson?.errorMessage)) {
        const responseAvlList = responseJson?.avlDayList[0];
        const updatedAvlDayList = avlDayList.map((avl) =>
          avl.availablityDate === selectedDate.availablityDate ? { ...responseAvlList } : avl,
        );
        currentTrainListObject = {
          ...currentTrainListObject,
          availabilityResponse: {
            ...currentTrainListObject.availabilityResponse,
            avlDayList: updatedAvlDayList,
          },
        };
        dispatch({
          type: ACTION_UPDATE_NEARBY_DATES_TTU,
          data: { currentTrainListObject, selectedCardHash },
        });
        trackClickEventProp61(LISTING_PAGE_TRACKING_KEY, NEARBY_DATES_EVENTS.tapToUpdateClick);
      } else {
        showShortToast(_label(responseJson?.errorMessage));
        trackClickEventProp61(
          LISTING_PAGE_TRACKING_KEY,
          NEARBY_DATES_EVENTS.tapToUpdateClickOutsideARP,
        );
      }
    } catch (e) {
      showShortToast(_label('something_went_wrong'));
      console.error('Error in fetching nearby dates ttu response: ', e);
    }
  };

  export const displayAvailDepletionListingBottomSheet = (value: boolean) => (dispatch) => {
    dispatch({
      type: ACTION_DISPLAY_AVAIL_DEPLETION_BOTTOM_SHEET,
      data: {
        displayAvailDepletionBottomSheet: value,
      },
    });
    if (value) {
      trackNewListingClickEvent(RAIL_EVENTS.LISTING.RAILS_AVAIL_DEPLETION_BS_SHOWN);
    }
  };